
// import React, { useState } from "react";
// import { useParams } from "react-router-dom";
// import ConsultationModal from "@/components/ConsultationModal";
// import { Button } from "@/components/ui/button";
// import {
//   CheckCircle,
//   Clock,
//   Star,
//   Users,
//   Shield,
//   ArrowRight,
//   Phone,
//   ChevronDown,
//   ChevronUp,
//   Award,
//   Heart,
//   MapPin,
//   Mail,
//   Facebook,
//   Twitter,
//   Instagram,
//   Youtube,
//   Menu,
//   X,
//   Calendar,
//   ThumbsUp,
//   Activity,
//   Plane,
//   MessageCircle,
//   FileText,
//   Video,
//   Building2,
//   HeartPulse,
//   Microscope,
//   Stethoscope,
//   BadgeCheck,
//   Globe,
//   Timer,
//   DollarSign,
//   TrendingDown,
//   Sparkles,
//   Send,
//   Zap,
//   Lock,
// } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { Input } from "@/components/ui/input";
// import { Label } from "@/components/ui/label";
// import { Textarea } from "@/components/ui/textarea";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "@/components/ui/select";
// import { Loader2 } from "lucide-react";
// import axios from "axios";

// // ============================================
// // TREATMENTS DATA
// // ============================================
// export const TREATMENTS_DATA = {
//   "cardiac-surgery": {
//     slug: "cardiac-surgery",
//     name: "Cardiac Surgery",
//     shortName: "Heart Surgery",
//     tagline: "Protect the Heart That Powers You",
//     heroSubtag:
//       "Save 70–80% on heart surgery. World-class cardiac centres. No waiting list.",
//     description:
//       "Comprehensive cardiac care from bypass surgery to valve repair, delivered by India's leading heart surgeons using the latest minimally invasive and robotic techniques. Our centres perform over 3,000 open-heart procedures annually with outcomes that match global benchmarks.",
//     heroImage:
//       "https://media.istockphoto.com/id/2254702983/photo/human-respiratory-system-anatomy-3d-illustrations.jpg?s=612x612&w=0&k=20&c=9wBVL5qN8YStJrCI2YiSN23Y4HrV86WyjGgWcv9qvGA=",
//     category: "Cardiology",
//     badge: "Life-Saving",
//     accentColor: "red",
//     costCard: {
//       label: "Complete cardiac package",
//       value: "₹2.5L–₹4.5L",
//       compare: "vs. ₹45L+ in the UK",
//       stay: "10–14 days hospital + 14–21 days recovery",
//       stayCompare: "vs. $40,000–$80,000 in the US",
//     },
//     stats: [
//       { label: "Success Rate", value: "97%", icon: Award },
//       { label: "Surgeries/Year", value: "3,000+", icon: Users },
//       { label: "Years Experience", value: "25+", icon: Shield },
//       { label: "ICU Recovery", value: "2-4 Days", icon: Clock },
//     ],
//     benefits: [
//       "Minimally invasive & robotic cardiac surgery options",
//       "Full spectrum: CABG, valve repair/replacement, ASD/VSD closure",
//       "24/7 cardiac catheterisation lab for emergencies",
//       "Dedicated cardiac ICU with 1:1 nurse-to-patient ratio",
//       "Integrated rehabilitation & cardiac physiotherapy",
//       "Insurance pre-authorisation support",
//       "Internationally accredited heart failure programme",
//       "Telemedicine follow-up for outstation patients",
//     ],
//     procedure: [
//       {
//         step: "01",
//         title: "Cardiac Evaluation",
//         desc: "ECG, echocardiography, coronary angiography and risk stratification.",
//         duration: "1-2 Days",
//         icon: Calendar,
//       },
//       {
//         step: "02",
//         title: "Pre-Op Optimisation",
//         desc: "Cardiology clearance, blood thinners review, anaesthesia assessment.",
//         duration: "3-5 Days",
//         icon: Activity,
//       },
//       {
//         step: "03",
//         title: "Surgery",
//         desc: "CABG, valve or structural procedure under cardiopulmonary bypass or off-pump.",
//         duration: "3-6 Hours",
//         icon: ThumbsUp,
//       },
//       {
//         step: "04",
//         title: "Cardiac Rehab",
//         desc: "Supervised exercise, diet counselling and medication optimisation.",
//         duration: "6-12 Weeks",
//         icon: Heart,
//       },
//     ],
//     faqs: [
//       {
//         q: "What is bypass surgery (CABG)?",
//         a: "Coronary Artery Bypass Grafting creates new routes for blood to flow around blocked arteries using vessels harvested from your leg, arm or chest wall.",
//       },
//       {
//         q: "How long is the hospital stay after open-heart surgery?",
//         a: "Most patients spend 2-4 days in the cardiac ICU followed by 4-6 days in a step-down ward — typically 7-10 days total.",
//       },
//       {
//         q: "Is robotic cardiac surgery safe?",
//         a: "Yes. Robotic-assisted procedures reduce blood loss, infection risk and recovery time while offering surgeons enhanced precision.",
//       },
//       {
//         q: "When can I return to work?",
//         a: "Desk workers usually return in 6-8 weeks; physically demanding jobs may require 3-4 months. Your surgeon will tailor the timeline.",
//       },
//       {
//         q: "Does insurance cover cardiac surgery?",
//         a: "Most group health policies and Ayushman Bharat cover cardiac procedures. Our insurance team assists with pre-authorisation and cashless claims.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Naresh Trehan",
//         specialty: "Cardiothoracic & Vascular Surgeon",
//         experience: "40 Years",
//         rating: 5.0,
//         reviews: 3800,
//         image: "https://randomuser.me/api/portraits/men/11.jpg",
//         qualifications: "MBBS, MS, FACC, FRCS (UK)",
//         hospital: "Medanta – The Medicity, Gurugram",
//       },
//       {
//         name: "Dr. Devi Prasad Shetty",
//         specialty: "Cardiac Surgeon",
//         experience: "35 Years",
//         rating: 4.9,
//         reviews: 4200,
//         image: "https://randomuser.me/api/portraits/men/21.jpg",
//         qualifications: "MBBS, FRCS (Glasg), FAMS",
//         hospital: "Narayana Health, Bengaluru",
//       },
//       {
//         name: "Dr. Meena Varma",
//         specialty: "Interventional Cardiologist",
//         experience: "22 Years",
//         rating: 4.8,
//         reviews: 1760,
//         image: "https://randomuser.me/api/portraits/women/31.jpg",
//         qualifications: "MBBS, MD (Cardiology), DM",
//         hospital: "Fortis Escorts, Delhi",
//       },
//     ],
//     testimonials: [
//       {
//         name: "Suresh Nair",
//         age: 58,
//         location: "Kochi",
//         text: "Triple bypass and I was walking in the corridor on day three. The cardiac team's precision and the ICU nursing staff's care were extraordinary.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/men/71.jpg",
//         treatment: "Triple CABG",
//         date: "April 2024",
//       },
//       {
//         name: "Kavita Singh",
//         age: 52,
//         location: "Lucknow",
//         text: "Mitral valve repair done robotically — no big scar, home in eight days. My cardiologist in Lucknow couldn't believe how quickly I recovered.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/women/52.jpg",
//         treatment: "Robotic Mitral Valve Repair",
//         date: "February 2024",
//       },
//       {
//         name: "Rajiv Kapoor",
//         age: 63,
//         location: "Chandigarh",
//         text: "From diagnosis to surgery in five days. The insurance team handled everything cashless. I only had to focus on getting better.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/men/48.jpg",
//         treatment: "Aortic Valve Replacement",
//         date: "March 2024",
//       },
//     ],
//   },
//   oncology: {
//     slug: "oncology",
//     name: "Cancer Treatment",
//     shortName: "Oncology",
//     tagline: "Precision Care. Real Hope.",
//     heroSubtag:
//       "Advanced cancer care at a fraction of Western costs. Personalised oncology teams. Proven outcomes.",
//     description:
//       "Comprehensive cancer care combining surgery, chemotherapy, radiation, immunotherapy and targeted therapy under one roof. Our multidisciplinary tumour boards review every case to deliver globally benchmarked, personalised treatment plans.",
//     heroImage:
//       "https://images.unsplash.com/photo-1719012577098-78efd07c5357?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDB8fG9uY29sb2d5fGVufDB8fDB8fHww",
//     category: "Oncology",
//     badge: "Comprehensive Care",
//     accentColor: "purple",
//     costCard: {
//       label: "Cancer treatment packages",
//       value: "₹3L–₹12L",
//       compare: "vs. ₹45L+ in the UK",
//       stay: "Varies by treatment: 4 weeks to 6 months for full course",
//       stayCompare: "vs. $100,000+ in the US",
//     },
//     stats: [
//       { label: "Tumour Types", value: "50+", icon: Award },
//       { label: "Patients/Year", value: "10,000+", icon: Users },
//       { label: "Years Experience", value: "25+", icon: Shield },
//       { label: "Tumour Board Review", value: "Weekly", icon: Clock },
//     ],
//     benefits: [
//       "PET-CT, liquid biopsy & molecular profiling for precise diagnosis",
//       "Robotic & laparoscopic onco-surgery",
//       "Linear accelerator (LINAC) with IMRT/IGRT/SBRT capabilities",
//       "Targeted therapy & immunotherapy infusion centre",
//       "Dedicated bone marrow transplant unit",
//       "Survivorship and palliative care programmes",
//       "Clinical trial access for novel therapies",
//       "Psychological counselling & nutritional support",
//     ],
//     procedure: [
//       {
//         step: "01",
//         title: "Diagnosis & Staging",
//         desc: "Biopsy, molecular testing, PET-CT scan and tumour board review.",
//         duration: "5-7 Days",
//         icon: Calendar,
//       },
//       {
//         step: "02",
//         title: "Treatment Planning",
//         desc: "Personalised protocol: surgery, chemo, radiation or combination.",
//         duration: "1 Week",
//         icon: Activity,
//       },
//       {
//         step: "03",
//         title: "Active Treatment",
//         desc: "Surgery, chemotherapy cycles or radiation — as planned by the board.",
//         duration: "4-24 Weeks",
//         icon: ThumbsUp,
//       },
//       {
//         step: "04",
//         title: "Survivorship & Monitoring",
//         desc: "Regular imaging, tumour markers and lifestyle support after remission.",
//         duration: "Ongoing",
//         icon: Heart,
//       },
//     ],
//     faqs: [
//       {
//         q: "What cancers do you treat?",
//         a: "We treat all major solid tumours (breast, lung, colon, prostate, cervical, liver, stomach) and blood cancers (leukaemia, lymphoma, myeloma), among 50+ tumour types.",
//       },
//       {
//         q: "What is a multidisciplinary tumour board?",
//         a: "A weekly meeting where surgeons, oncologists, radiologists, pathologists and support specialists jointly review each case to agree on the most effective personalised plan.",
//       },
//       {
//         q: "Is immunotherapy available?",
//         a: "Yes. We offer checkpoint inhibitors, CAR-T cell therapy and clinical trials for eligible patients across several cancer types.",
//       },
//       {
//         q: "How painful is chemotherapy?",
//         a: "Modern anti-nausea and supportive medications have greatly reduced side effects. Many patients continue working during treatment cycles.",
//       },
//       {
//         q: "Do you offer a second opinion?",
//         a: "Absolutely. You can upload reports for a digital second opinion from our senior oncologists within 48 hours.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Shyam Aggarwal",
//         specialty: "Medical Oncologist",
//         experience: "28 Years",
//         rating: 4.9,
//         reviews: 2100,
//         image: "https://randomuser.me/api/portraits/men/33.jpg",
//         qualifications: "MBBS, MD, DM (Oncology), MRCP",
//         hospital: "Sir Ganga Ram Hospital, Delhi",
//       },
//       {
//         name: "Dr. Reena Nair",
//         specialty: "Surgical Oncologist",
//         experience: "20 Years",
//         rating: 4.9,
//         reviews: 1540,
//         image: "https://randomuser.me/api/portraits/women/41.jpg",
//         qualifications: "MBBS, MS (Surgery), MCh (Onco)",
//         hospital: "Tata Memorial Hospital, Mumbai",
//       },
//       {
//         name: "Dr. Anand Mishra",
//         specialty: "Radiation Oncologist",
//         experience: "18 Years",
//         rating: 4.8,
//         reviews: 980,
//         image: "https://randomuser.me/api/portraits/men/61.jpg",
//         qualifications: "MBBS, MD (Radiation Oncology)",
//         hospital: "Apollo Cancer Centre, Chennai",
//       },
//     ],
//     testimonials: [
//       {
//         name: "Meena Desai",
//         age: 44,
//         location: "Ahmedabad",
//         text: "Stage 3 breast cancer, and today I am in complete remission. The tumour board ensured I got the right combination of surgery and targeted therapy from day one.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/women/62.jpg",
//         treatment: "Breast Cancer – Surgery + Chemo",
//         date: "January 2024",
//       },
//       {
//         name: "Harish Bose",
//         age: 55,
//         location: "Kolkata",
//         text: "Colon cancer caught at stage 2 thanks to their early-detection programme. Robotic surgery, no colostomy bag, back home in 10 days. Truly life-changing.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/men/75.jpg",
//         treatment: "Colorectal Cancer – Robotic Surgery",
//         date: "March 2024",
//       },
//       {
//         name: "Preethi Rajan",
//         age: 38,
//         location: "Chennai",
//         text: "The counsellors and nutritionists made chemotherapy far more bearable than I feared. I never felt alone throughout my entire treatment journey.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/women/29.jpg",
//         treatment: "Ovarian Cancer – Chemo + Immunotherapy",
//         date: "April 2024",
//       },
//     ],
//   },
// };

// // ============================================
// // PAXGROW EXTRA DATA
// // ============================================
// const PAXGROW_DATA = {
//   oncology: {
//     whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//     whyIndiaTitle: "Why African Patients Choose India",
//     whyIndiaReasons: [
//       "NABH-accredited oncology departments with PET-CT, Da Vinci robotic surgery, CyberKnife",
//       "Multidisciplinary tumour boards review every case within 48 hours of arrival",
//       "Treatment begins within 7 days — critical for aggressive cancers",
//       "Tata Memorial, AIIMS, Apollo, Fortis, Max — global oncology rankings",
//     ],
//     conditionsTitle: "Cancer Treatment Conditions We Facilitate",
//     conditions: [
//       "Breast Cancer",
//       "Lung Cancer",
//       "Prostate Cancer",
//       "Blood Cancers (Leukaemia, Lymphoma)",
//       "Colorectal Cancer",
//       "Cervical Cancer",
//       "Head & Neck Cancer",
//     ],
//     stayValue: "Varies by treatment: 4 weeks to 6 months for full course",
//     costTitle: "Why India for Cancer Treatment?",
//     costRows: [
//       {
//         procedure: "Chemotherapy (per cycle)",
//         india: "₹25,000–₹80,000",
//         africa: "$2,000–$6,000",
//         ukusa: "$10,000–$30,000",
//       },
//       {
//         procedure: "Radiation Therapy (full course)",
//         india: "₹2.5L–₹5L",
//         africa: "$25,000–$50,000",
//         ukusa: "$80,000–$150,000",
//       },
//       {
//         procedure: "Bone Marrow Transplant",
//         india: "₹12L–₹25L",
//         africa: "Largely unavailable",
//         ukusa: "$150,000–$300,000",
//       },
//     ],
//   },
//   "cardiac-surgery": {
//     whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//     whyIndiaTitle: "Why African Patients Choose India",
//     whyIndiaReasons: [
//       "India's cardiac success rates: 97–99% for CABG at top-tier hospitals",
//       "No waiting lists — surgery within 7–14 days of arrival",
//       "Surgeons trained at Cleveland Clinic, Mayo Clinic, and UK NHS",
//       "Apollo, Fortis, Medanta, Max — all NABH and JCI accredited",
//     ],
//     conditionsTitle: "Cardiac Surgery Conditions We Facilitate",
//     conditions: [
//       "Coronary Artery Bypass Graft (CABG)",
//       "Heart Valve Replacement / Repair",
//       "Angioplasty & Stenting",
//       "Pacemaker Implantation",
//       "Atrial Septal Defect (ASD) Repair",
//       "Congenital Heart Disease Surgery",
//     ],
//     stayValue: "10–14 days hospital + 14–21 days recovery",
//     costTitle: "Why India for Cardiac Surgery?",
//     costRows: [
//       {
//         procedure: "CABG (Heart Bypass)",
//         india: "₹2.5L – ₹3.8L",
//         africa: "$18,000–$25,000",
//         ukusa: "$40,000–$80,000",
//       },
//       {
//         procedure: "Heart Valve Replacement",
//         india: "₹2.8L – ₹4.2L",
//         africa: "$20,000–$28,000",
//         ukusa: "$50,000–$100,000",
//       },
//       {
//         procedure: "Angioplasty / Stenting",
//         india: "₹1.2L – ₹2.5L",
//         africa: "$10,000–$18,000",
//         ukusa: "$25,000–$50,000",
//       },
//     ],
//   },
// };

// const PROCESS_STEPS = [
//   {
//     num: 1,
//     title: "Send your reports — free review",
//     desc: "WhatsApp your medical reports to PaxGrow. Within 48 hours, Samar personally sends a written summary: condition, treatment options, cost estimate, and recommended hospital. No charge. No commitment.",
//     icon: FileText,
//     color: "from-orange-400 to-orange-600",
//     iconBg: "bg-orange-100",
//     iconColor: "text-orange-600",
//   },
//   {
//     num: 2,
//     title: "Free video consultation with your surgeon",
//     desc: "PaxGrow arranges a direct video call between you and your treating specialist in India. You speak to the surgeon before committing to anything. Formal treatment plan and cost estimate provided in writing.",
//     icon: Video,
//     color: "from-blue-400 to-blue-600",
//     iconBg: "bg-blue-100",
//     iconColor: "text-blue-600",
//   },
//   {
//     num: 3,
//     title: "Visa, flights, and accommodation arranged",
//     desc: "PaxGrow provides your hospital visa invitation letter within 3 days of confirming your case. We guide you through the e-Medical Visa process (Kenya: 24–72hrs), and arrange accommodation near your hospital.",
//     icon: Plane,
//     color: "from-violet-400 to-violet-600",
//     iconBg: "bg-violet-100",
//     iconColor: "text-violet-600",
//   },
//   {
//     num: 4,
//     title: "Airport pickup and full in-hospital support",
//     desc: "PaxGrow coordinator meets you at the airport, accompanies you to the hospital, and is available throughout your stay. Translation, daily updates to family at home, and discharge documentation all handled.",
//     icon: Building2,
//     color: "from-green-400 to-green-600",
//     iconBg: "bg-green-100",
//     iconColor: "text-green-600",
//   },
//   {
//     num: 5,
//     title: "90-day follow-up after you return home",
//     desc: "PaxGrow maintains contact for 90 days after your return. Two telemedicine follow-up sessions with your Indian surgeon are included. If anything concerns you, we connect you with your treating team immediately.",
//     icon: HeartPulse,
//     color: "from-rose-400 to-rose-600",
//     iconBg: "bg-rose-100",
//     iconColor: "text-rose-600",
//   },
// ];

// // ============================================
// // WHATSAPP NUMBER
// // ============================================
// const WHATSAPP_NUMBER = "917289007800";

// // ============================================
// // API
// // ============================================
// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const treatmentOptions = [
//   "Cardiology",
//   "Orthopedics",
//   "Oncology",
//   "Neurology & Spine",
//   "Organ Transplant",
//   "Dental Care",
//   "Skin Care & Dermatology",
//   "Cosmetic Surgery",
//   "IVF & Fertility",
//   "Bariatric Surgery",
//   "Eye Care",
//   "ENT & Cochlear",
//   "Ayurveda & Wellness",
//   "Hair Transplant",
//   "Other",
// ];

// const countries = [
//   "Afghanistan",
//   "Bahrain",
//   "Bangladesh",
//   "Cameroon",
//   "Egypt",
//   "Ethiopia",
//   "Ghana",
//   "India",
//   "Indonesia",
//   "Iraq",
//   "Kenya",
//   "Kuwait",
//   "Malaysia",
//   "Mauritius",
//   "Nigeria",
//   "Oman",
//   "Pakistan",
//   "Qatar",
//   "Rwanda",
//   "Saudi Arabia",
//   "Singapore",
//   "Somalia",
//   "South Africa",
//   "Sri Lanka",
//   "Sudan",
//   "Tanzania",
//   "Thailand",
//   "UAE",
//   "Uganda",
//   "UK",
//   "USA",
//   "Vietnam",
//   "Yemen",
//   "Zambia",
//   "Zimbabwe",
//   "Other",
// ];

// // ============================================
// // SCREEN 1 — HERO
// // ============================================
// const HeroScreen = ({ treatment }) => {
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     country: "",
//     treatment: treatment.name || "",
//     message: "",
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       await axios.post(`${API}/consultations`, form);
//       const whatsappMessage = encodeURIComponent(
//         `Hi, I just submitted a consultation request.\n\nName: ${form.name}\nPhone: ${form.phone}\nTreatment: ${form.treatment}\nCountry: ${form.country}`
//       );
//       const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${whatsappMessage}`;
//       navigate("/thank-you", { state: { formData: form, whatsappUrl } });
//     } catch (err) {
//       console.error(err);
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="relative min-h-screen flex items-center bg-slate-900 overflow-hidden">
//       {/* Background */}
//       <div
//         className="absolute inset-0 bg-cover bg-center"
//         style={{ backgroundImage: `url(${treatment.heroImage})` }}
//       />
//       <div className="absolute inset-0 bg-gradient-to-r from-slate-900/97 via-slate-900/85 to-slate-900/50" />

//       {/* Decorative orbs */}
//       <div className="absolute top-20 right-10 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl pointer-events-none" />
//       <div className="absolute bottom-20 left-10 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />

//       <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 w-full">
//         <div className="grid lg:grid-cols-2 gap-10 items-start">
//           {/* LEFT COLUMN */}
//           <div className="lg:sticky lg:top-20">
//             {/* Category badge */}
//             <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/30 text-orange-300 rounded-full px-4 py-1.5 text-xs font-semibold mb-5">
//               <Award className="w-3.5 h-3.5" />
//               {treatment.category} · {treatment.badge}
//             </div>

//             <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-3">
//               {treatment.name}
//             </h1>
//             <p className="text-xl text-orange-400 font-semibold mb-3">
//               {treatment.tagline}
//             </p>

//             {/* Savings strip */}
//             <div className="inline-flex items-center gap-2 bg-green-500/15 border border-green-500/30 text-white rounded-xl px-4 py-2.5 text-sm font-medium mb-5">
//               <TrendingDown className="w-4 h-4 text-white shrink-0" />
//               {treatment.heroSubtag}
//             </div>

//             <p className="text-slate-300 text-sm leading-relaxed mb-6 max-w-lg">
//               {treatment.description}
//             </p>

//             {/* Key stats */}
//             <div className="flex flex-wrap gap-6 mb-6">
//               {treatment.stats.slice(0, 2).map((stat, i) => (
//                 <div key={i} className="text-white">
//                   <div className="text-2xl font-bold text-orange-400">
//                     {stat.value}
//                   </div>
//                   <div className="text-xs text-slate-400">{stat.label}</div>
//                 </div>
//               ))}
//             </div>

//             {/* Primary WhatsApp CTA */}
//             <a
//               href={`https://wa.me/${WHATSAPP_NUMBER}`}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-full px-7 py-4 font-semibold text-sm transition-all shadow-lg shadow-green-500/30 hover:shadow-green-500/50 hover:-translate-y-0.5 mb-6"
//             >
//               <MessageCircle className="w-5 h-5 fill-white" />
//               Send Reports — Free 48hr Review
//             </a>

//             {/* Trust icons */}
//             <div className="grid grid-cols-2 gap-2 mb-6 max-w-xs">
//               {[
//                 {
//                   icon: DollarSign,
//                   label: "Zero coordination fees",
//                   color: "text-green-400",
//                 },
//                 {
//                   icon: Timer,
//                   label: "Reply within 48 hours",
//                   color: "text-blue-400",
//                 },
//                 {
//                   icon: BadgeCheck,
//                   label: "JCI & NABH hospitals",
//                   color: "text-violet-400",
//                 },
//                 {
//                   icon: Plane,
//                   label: "Visa guidance included",
//                   color: "text-orange-400",
//                 },
//               ].map((b, i) => (
//                 <div key={i} className="flex items-center gap-2">
//                   <b.icon className={`w-3.5 h-3.5 shrink-0 ${b.color}`} />
//                   <span className="text-slate-300 text-xs">{b.label}</span>
//                 </div>
//               ))}
//             </div>

//             {/* Cost card */}
//             {treatment.costCard && (
//               <div className="bg-white/10 backdrop-blur border border-white/20 rounded-2xl p-4 max-w-xs">
//                 <div className="flex items-center gap-2 mb-2">
//                   <div className="w-7 h-7 bg-orange-500/20 rounded-lg flex items-center justify-center">
//                     <TrendingDown className="w-3.5 h-3.5 text-orange-400" />
//                   </div>
//                   <span className="text-white/60 text-xs font-medium">
//                     {treatment.costCard.label}
//                   </span>
//                 </div>
//                 <div className="text-2xl font-bold text-orange-400 leading-none mb-1">
//                   {treatment.costCard.value}
//                 </div>
//                 <div className="text-white/40 text-xs">
//                   {treatment.costCard.compare}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* RIGHT COLUMN — FORM */}
//           <div className="lg:sticky lg:top-20">
//             <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
//               {/* Form header */}
//               <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-5 text-white">
//                 <div className="flex items-center gap-3 mb-2">
//                   <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
//                     <FileText className="w-5 h-5 text-white" />
//                   </div>
//                   <div>
//                     <h3 className="font-bold text-xl">Free Consultation</h3>
//                     <p className="text-orange-100 text-xs">
//                       Expert advice · No commitment · 48hr reply
//                     </p>
//                   </div>
//                 </div>
//                 {/* Social proof strip */}
//                 <div className="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2 mt-2">
//                   <div className="flex -space-x-2">
//                     {["men/11", "women/31", "men/21"].map((p, i) => (
//                       <img
//                         key={i}
//                         src={`https://randomuser.me/api/portraits/${p}.jpg`}
//                         alt=""
//                         className="w-6 h-6 rounded-full border-2 border-orange-500 object-cover"
//                       />
//                     ))}
//                   </div>
//                   <span className="text-orange-100 text-xs">
//                     <strong className="text-white">127 patients</strong>{" "}
//                     consulted this week
//                   </span>
//                 </div>
//               </div>

//               <div className="p-6">
//                 <form onSubmit={handleSubmit} className="space-y-4">
//                   <div>
//                     <Label className="text-slate-700 text-sm font-semibold">
//                       Full Name *
//                     </Label>
//                     <Input
//                       required
//                       value={form.name}
//                       onChange={(e) =>
//                         setForm({ ...form, name: e.target.value })
//                       }
//                       placeholder="Your full name"
//                       className="mt-1 rounded-xl border-slate-200 focus:border-orange-400 focus:ring-orange-400"
//                     />
//                   </div>
//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                     <div>
//                       <Label className="text-slate-700 text-sm font-semibold">
//                         Email *
//                       </Label>
//                       <Input
//                         type="email"
//                         required
//                         value={form.email}
//                         onChange={(e) =>
//                           setForm({ ...form, email: e.target.value })
//                         }
//                         placeholder="your@email.com"
//                         className="mt-1 rounded-xl border-slate-200 focus:border-orange-400"
//                       />
//                     </div>
//                     <div>
//                       <Label className="text-slate-700 text-sm font-semibold">
//                         Phone *
//                       </Label>
//                       <Input
//                         required
//                         value={form.phone}
//                         onChange={(e) =>
//                           setForm({ ...form, phone: e.target.value })
//                         }
//                         placeholder="+1 234 567 890"
//                         className="mt-1 rounded-xl border-slate-200 focus:border-orange-400"
//                       />
//                     </div>
//                   </div>
//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                     <div>
//                       <Label className="text-slate-700 text-sm font-semibold">
//                         Country *
//                       </Label>
//                       <Select
//                         onValueChange={(v) =>
//                           setForm({ ...form, country: v })
//                         }
//                       >
//                         <SelectTrigger className="mt-1 rounded-xl border-slate-200">
//                           <SelectValue placeholder="Select country" />
//                         </SelectTrigger>
//                         <SelectContent>
//                           {countries.map((c) => (
//                             <SelectItem key={c} value={c}>
//                               {c}
//                             </SelectItem>
//                           ))}
//                         </SelectContent>
//                       </Select>
//                     </div>
//                     <div>
//                       <Label className="text-slate-700 text-sm font-semibold">
//                         Treatment *
//                       </Label>
//                       <Select
//                         value={form.treatment}
//                         onValueChange={(v) =>
//                           setForm({ ...form, treatment: v })
//                         }
//                       >
//                         <SelectTrigger className="mt-1 rounded-xl border-slate-200">
//                           <SelectValue placeholder="Select treatment" />
//                         </SelectTrigger>
//                         <SelectContent>
//                           {treatmentOptions.map((t) => (
//                             <SelectItem key={t} value={t}>
//                               {t}
//                             </SelectItem>
//                           ))}
//                         </SelectContent>
//                       </Select>
//                     </div>
//                   </div>
//                   <div>
//                     <Label className="text-slate-700 text-sm font-semibold">
//                       Medical Details{" "}
//                       <span className="text-slate-400 font-normal">
//                         (Optional)
//                       </span>
//                     </Label>
//                     <Textarea
//                       value={form.message}
//                       onChange={(e) =>
//                         setForm({ ...form, message: e.target.value })
//                       }
//                       placeholder="Briefly describe your condition or attach reports later on WhatsApp..."
//                       rows={3}
//                       className="mt-1 rounded-xl border-slate-200 focus:border-orange-400"
//                     />
//                   </div>
//                   <Button
//                     type="submit"
//                     disabled={loading}
//                     className="w-full bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-bold h-12 shadow-md shadow-orange-200 text-sm"
//                   >
//                     {loading ? (
//                       <Loader2 className="h-4 w-4 animate-spin mr-2" />
//                     ) : (
//                       <Send className="h-4 w-4 mr-2" />
//                     )}
//                     {loading ? "Submitting..." : "Get My Free Consultation"}
//                   </Button>

//                   {/* Trust line */}
//                   <div className="flex items-center justify-center gap-4 pt-1">
//                     <span className="flex items-center gap-1.5 text-xs text-slate-400">
//                       <Lock className="w-3 h-3 text-slate-400" />
//                       100% Confidential
//                     </span>
//                     <span className="text-slate-200">·</span>
//                     <span className="flex items-center gap-1.5 text-xs text-slate-400">
//                       <Zap className="w-3 h-3 text-slate-400" />
//                       Reply in 48hrs
//                     </span>
//                     <span className="text-slate-200">·</span>
//                     <span className="flex items-center gap-1.5 text-xs text-slate-400">
//                       <DollarSign className="w-3 h-3 text-slate-400" />
//                       Zero Fees
//                     </span>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Scroll hint */}
//       <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40">
//         <span className="text-xs">Scroll to explore</span>
//         <div className="w-5 h-8 border border-white/20 rounded-full flex items-start justify-center p-1">
//           <div className="w-1 h-2 bg-white/40 rounded-full animate-bounce" />
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // SCREEN 2 — STATS
// // ============================================
// const StatsScreen = ({ treatment }) => {
//   const statStyles = [
//     {
//       bg: "bg-orange-50",
//       border: "border-orange-200",
//       iconBg: "bg-orange-100",
//       val: "text-orange-700",
//       icon: "text-orange-600",
//     },
//     {
//       bg: "bg-blue-50",
//       border: "border-blue-200",
//       iconBg: "bg-blue-100",
//       val: "text-blue-700",
//       icon: "text-blue-600",
//     },
//     {
//       bg: "bg-violet-50",
//       border: "border-violet-200",
//       iconBg: "bg-violet-100",
//       val: "text-violet-700",
//       icon: "text-violet-600",
//     },
//     {
//       bg: "bg-green-50",
//       border: "border-green-200",
//       iconBg: "bg-green-100",
//       val: "text-green-700",
//       icon: "text-green-600",
//     },
//   ];

//   return (
//     <section className="py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-10">
//           <span className="text-orange-600 font-medium text-xs uppercase tracking-widest">
//             Our track record
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 mb-2 leading-tight">
//             Numbers that speak for themselves
//           </h2>
//           <p className="text-slate-500 text-sm max-w-md mx-auto leading-relaxed">
//             Two decades of clinical excellence trusted by patients across every
//             corner of India.
//           </p>
//         </div>

//         <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
//           {treatment.stats.map((stat, i) => {
//             const Icon = stat.icon;
//             const s = statStyles[i];
//             return (
//               <div
//                 key={i}
//                 className={`relative overflow-hidden rounded-2xl border ${s.bg} ${s.border} p-6 text-center hover:-translate-y-1 hover:shadow-lg transition-all duration-200`}
//               >
//                 <div
//                   className={`absolute -top-5 -right-5 w-20 h-20 rounded-full ${s.iconBg} opacity-40`}
//                 />
//                 <div
//                   className={`relative z-10 w-12 h-12 ${s.iconBg} rounded-xl flex items-center justify-center mx-auto mb-4`}
//                 >
//                   <Icon className={`w-5 h-5 ${s.icon}`} />
//                 </div>
//                 <div
//                   className={`relative z-10 text-3xl sm:text-4xl font-bold ${s.val} mb-1.5 leading-none`}
//                 >
//                   {stat.value}
//                 </div>
//                 <div className="relative z-10 text-slate-500 text-xs font-medium">
//                   {stat.label}
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         <div className="bg-slate-900 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
//           <div className="flex-1">
//             <h3 className="text-xl font-bold text-white mb-2">
//               India's most trusted medical centre
//             </h3>
//             <p className="text-slate-400 text-sm">
//               Setting the standard in patient outcomes since 2016.
//             </p>
//           </div>
//           <div className="hidden md:block w-px self-stretch bg-white/10" />
//           <div className="flex gap-8 shrink-0">
//             {[
//               { val: "50+", lbl: "Hospitals" },
//               { val: "25+", lbl: "Cities" },
//               { val: "30+", lbl: "Awards" },
//             ].map((s) => (
//               <div key={s.lbl} className="text-center">
//                 <div className="text-3xl font-bold text-orange-400">
//                   {s.val}
//                 </div>
//                 <div className="text-slate-500 text-xs mt-1">{s.lbl}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // WHY INDIA SCREEN
// // ============================================
// const WhyIndiaScreen = ({ treatment }) => {
//   const data = PAXGROW_DATA[treatment.slug];
//   if (!data) return null;

//   return (
//     <section className="py-16 bg-slate-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">
//             {data.whyIndiaSubtitle}
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4 leading-tight">
//             {data.whyIndiaTitle}
//           </h2>
//           <p className="text-slate-500 text-sm max-w-lg mx-auto">
//             Top-tier hospitals. No waiting lists. Expert surgeons. At a fraction
//             of Western costs.
//           </p>
//         </div>

//         <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
//           {[
//             {
//               icon: Microscope,
//               color: "bg-orange-100 text-orange-600",
//               border: "border-orange-200",
//             },
//             {
//               icon: Stethoscope,
//               color: "bg-blue-100 text-blue-600",
//               border: "border-blue-200",
//             },
//             {
//               icon: Timer,
//               color: "bg-violet-100 text-violet-600",
//               border: "border-violet-200",
//             },
//             {
//               icon: Globe,
//               color: "bg-green-100 text-green-600",
//               border: "border-green-200",
//             },
//           ].map((style, i) => {
//             const Icon = style.icon;
//             return (
//               <div
//                 key={i}
//                 className={`bg-white rounded-2xl border ${style.border} p-6 hover:shadow-md transition-all`}
//               >
//                 <div
//                   className={`w-11 h-11 rounded-xl ${style.color} flex items-center justify-center mb-4`}
//                 >
//                   <Icon className="w-5 h-5" />
//                 </div>
//                 <p className="text-slate-700 text-sm font-medium leading-relaxed">
//                   {data.whyIndiaReasons[i]}
//                 </p>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // PROCESS SCREEN
// // ============================================
// const ProcessScreen = ({ treatment }) => {
//   const data = PAXGROW_DATA[treatment.slug];
//   if (!data) return null;

//   return (
//     <section className="py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">
//             THE PROCESS
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4 leading-tight">
//             From First WhatsApp
//             <br />
//             to Safe Return Home
//           </h2>
//           <p className="text-slate-500 text-sm max-w-md mx-auto">
//             PaxGrow manages every step so you can focus entirely on getting
//             better.
//           </p>
//         </div>

//         {/* Timeline */}
//         <div className="relative max-w-3xl mx-auto">
//           <div className="absolute left-6 top-6 bottom-6 w-0.5 bg-gradient-to-b from-orange-300 via-violet-300 to-rose-300 hidden sm:block" />
//           <div className="space-y-6">
//             {PROCESS_STEPS.map((step) => {
//               const Icon = step.icon;
//               return (
//                 <div key={step.num} className="relative flex gap-5 sm:gap-8">
//                   <div className="relative z-10 shrink-0">
//                     <div
//                       className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${step.color} flex items-center justify-center shadow-lg`}
//                     >
//                       <Icon className="w-5 h-5 text-white" />
//                     </div>
//                     <div className="absolute -top-1 -right-1 w-5 h-5 bg-slate-900 text-white rounded-full text-[10px] font-bold flex items-center justify-center">
//                       {step.num}
//                     </div>
//                   </div>
//                   <div className="flex-1 bg-slate-50 border border-slate-100 rounded-2xl p-5 hover:border-orange-200 hover:shadow-sm transition-all">
//                     <h3 className="font-semibold text-slate-900 text-sm mb-2">
//                       {step.title}
//                     </h3>
//                     <p className="text-slate-500 text-xs leading-relaxed">
//                       {step.desc}
//                     </p>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>

//         {/* CTA */}
//         <div className="mt-10 text-center">
//           <a
//             href={`https://wa.me/${WHATSAPP_NUMBER}`}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-full px-8 py-4 font-semibold text-sm transition-all shadow-lg shadow-green-500/20"
//           >
//             <MessageCircle className="w-5 h-5 fill-white" />
//             Start with Step 1 — Send Your Reports
//           </a>
//           <p className="text-slate-400 text-xs mt-3">
//             Free review · No commitment · Reply within 48 hours
//           </p>
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // CONDITIONS SCREEN
// // ============================================
// const ConditionsScreen = ({ treatment }) => {
//   const data = PAXGROW_DATA[treatment.slug];
//   if (!data) return null;
//   const half = Math.ceil(data.conditions.length / 2);
//   const col1 = data.conditions.slice(0, half);
//   const col2 = data.conditions.slice(half);

//   return (
//     <section className="py-16 bg-slate-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="mb-8">
//           <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">
//             WHAT WE TREAT
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 leading-tight">
//             {data.conditionsTitle}
//           </h2>
//         </div>
//         <div className="grid md:grid-cols-2 gap-0 border border-slate-200 rounded-2xl overflow-hidden mb-5 bg-white">
//           {[col1, col2].map((col, ci) =>
//             col.map((cond, ri) => (
//               <div
//                 key={`${ci}-${ri}`}
//                 className={`flex items-center gap-3 px-6 py-4 hover:bg-orange-50 transition-colors
//                   ${ri < col.length - 1 ? "border-b border-slate-100" : ""}
//                   ${ci === 0 ? "md:border-r border-slate-100" : ""}
//                 `}
//               >
//                 <div className="w-7 h-7 bg-orange-100 rounded-lg flex items-center justify-center shrink-0">
//                   <ArrowRight className="w-3.5 h-3.5 text-orange-500" />
//                 </div>
//                 <span className="text-slate-700 text-sm font-medium">
//                   {cond}
//                 </span>
//               </div>
//             ))
//           )}
//         </div>
//         <div className="flex items-center gap-4 bg-gradient-to-r from-orange-50 to-amber-50 border border-orange-200 rounded-2xl px-6 py-5">
//           <div className="w-11 h-11 rounded-xl bg-orange-500 flex items-center justify-center shrink-0">
//             <Plane className="w-5 h-5 text-white" />
//           </div>
//           <div>
//             <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">
//               Typical India Stay
//             </span>
//             <p className="text-slate-700 font-semibold text-sm mt-0.5">
//               {data.stayValue}
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // COST COMPARISON SCREEN
// // ============================================
// const CostComparisonScreen = ({ treatment }) => {
//   const data = PAXGROW_DATA[treatment.slug];
//   if (!data) return null;

//   return (
//     <section className="py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="mb-8">
//           <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">
//             COST COMPARISON
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 leading-tight">
//             {data.costTitle}
//           </h2>
//         </div>

//         {/* Desktop table */}
//         <div className="hidden sm:block rounded-2xl overflow-hidden border border-slate-200 shadow-sm mb-4">
//           <div className="grid grid-cols-4 bg-orange-600 text-white text-xs font-bold uppercase tracking-wider">
//             <div className="px-6 py-4">Procedure</div>
//             <div className="px-6 py-4 text-center">🇮🇳 India (PaxGrow)</div>
//             <div className="px-6 py-4 text-center">Africa (local)</div>
//             <div className="px-6 py-4 text-center">UK / USA</div>
//           </div>
//           {data.costRows.map((row, i) => (
//             <div
//               key={i}
//               className={`grid grid-cols-4 border-t border-slate-100 hover:bg-orange-50/40 transition-colors ${i % 2 === 0 ? "bg-white" : "bg-slate-50/60"}`}
//             >
//               <div className="px-6 py-5 text-slate-700 text-sm font-medium">
//                 {row.procedure}
//               </div>
//               <div className="px-6 py-5 text-center">
//                 <span className="text-orange-600 font-bold text-sm">
//                   {row.india}
//                 </span>
//               </div>
//               <div className="px-6 py-5 text-center text-slate-500 text-sm">
//                 {row.africa}
//               </div>
//               <div className="px-6 py-5 text-center text-slate-500 text-sm">
//                 {row.ukusa}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Mobile cards */}
//         <div className="sm:hidden space-y-4 mb-4">
//           {data.costRows.map((row, i) => (
//             <div
//               key={i}
//               className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm"
//             >
//               <p className="text-slate-800 font-semibold text-sm mb-4">
//                 {row.procedure}
//               </p>
//               <div className="space-y-2.5">
//                 {[
//                   {
//                     label: "🇮🇳 India (PaxGrow)",
//                     val: row.india,
//                     highlight: true,
//                   },
//                   { label: "Africa (local)", val: row.africa, highlight: false },
//                   { label: "UK / USA", val: row.ukusa, highlight: false },
//                 ].map((r) => (
//                   <div
//                     key={r.label}
//                     className="flex justify-between items-center"
//                   >
//                     <span className="text-slate-500 text-xs">{r.label}</span>
//                     <span
//                       className={`text-sm font-semibold ${r.highlight ? "text-orange-600" : "text-slate-600"}`}
//                     >
//                       {r.val}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>

//         <p className="text-slate-400 text-xs mb-5">
//           All costs are approximate and verified from hospital packages (Q1
//           2026). Final quote provided after medical report review.
//         </p>
//         <div className="flex flex-wrap items-center gap-3">
//           {["NABH", "JCI"].map((badge) => (
//             <span
//               key={badge}
//               className="bg-orange-50 border border-orange-200 text-orange-700 text-xs font-semibold px-4 py-1.5 rounded-full"
//             >
//               {badge}
//             </span>
//           ))}
//           <span className="text-slate-400 text-xs">
//             All PaxGrow partner hospitals hold NABH or JCI accreditation —
//             verifiable at nabh.co
//           </span>
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // WHY CHOOSE SCREEN
// // ============================================
// const WhyChooseScreen = ({ treatment }) => (
//   <section className="py-16 bg-slate-50">
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <div className="grid lg:grid-cols-2 gap-14 items-center">
//         <div>
//           <span className="text-orange-600 font-semibold text-sm uppercase tracking-widest">
//             Treatment Benefits
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4">
//             Why Choose {treatment.shortName}?
//           </h2>
//           <p className="text-slate-500 mb-7 leading-relaxed text-sm">
//             Our advanced approach to {treatment.shortName.toLowerCase()} ensures
//             the best possible outcome for every patient.
//           </p>
//           <div className="space-y-3">
//             {treatment.benefits.map((benefit, i) => (
//               <div
//                 key={i}
//                 className="flex items-start gap-4 bg-white rounded-2xl p-4 border border-slate-100 shadow-sm hover:shadow-md hover:border-orange-100 transition-all group"
//               >
//                 <div className="w-8 h-8 bg-orange-100 rounded-xl flex items-center justify-center shrink-0 group-hover:bg-orange-600 transition-colors">
//                   <CheckCircle className="w-4 h-4 text-orange-600 group-hover:text-white transition-colors" />
//                 </div>
//                 <p className="text-slate-700 text-sm font-medium pt-1">
//                   {benefit}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="space-y-5">
//           <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl p-8 text-white">
//             <div className="flex items-center gap-3 mb-6">
//               <div className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center">
//                 <Award className="w-6 h-6 text-white" />
//               </div>
//               <div>
//                 <div className="font-bold text-lg">Top Rated Treatment</div>
//                 <div className="text-orange-200 text-xs">
//                   By India's Medical Association
//                 </div>
//               </div>
//             </div>
//             <div className="grid grid-cols-2 gap-4">
//               {[
//                 { label: "Experience", value: "15+ Years" },
//                 { label: "Patients", value: "10k+" },
//                 { label: "Experts", value: "50+" },
//                 { label: "Centers", value: "100+" },
//               ].map((item) => (
//                 <div
//                   key={item.label}
//                   className="bg-white/10 rounded-2xl p-4 text-center"
//                 >
//                   <div className="text-2xl font-bold">{item.value}</div>
//                   <div className="text-orange-200 text-xs mt-1">
//                     {item.label}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* CTA card */}
//           <div className="bg-white rounded-3xl border border-slate-200 shadow-xl p-8">
//             <h4 className="font-bold text-2xl text-slate-900 mb-3 leading-tight">
//               Not Sure If You Need{" "}
//               <span className="text-orange-600">Surgery</span>?
//             </h4>
//             <div className="space-y-2 mb-6">
//               {[
//                 "Get a free opinion from our expert specialists",
//                 "Zero cost, zero commitment — just expert advice",
//               ].map((txt, i) => (
//                 <div key={i} className="flex items-start gap-2">
//                   <CheckCircle className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" />
//                   <p className="text-slate-600 text-sm">{txt}</p>
//                 </div>
//               ))}
//             </div>
//             <ConsultationModal
//               trigger={
//                 <Button className="w-full bg-orange-600 hover:bg-orange-700 text-white rounded-xl py-5 font-bold text-sm mb-3">
//                   📞 Get Free Consultation{" "}
//                   <ArrowRight className="ml-2 h-4 w-4" />
//                 </Button>
//               }
//             />
//             <a
//               href={`https://wa.me/${WHATSAPP_NUMBER}`}
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <Button
//                 variant="outline"
//                 className="w-full border-2 border-green-500 text-green-600 hover:bg-green-50 rounded-xl py-5 font-bold text-sm"
//               >
//                 <MessageCircle className="w-4 h-4 mr-2 fill-green-500 text-green-500" />
//                 Chat on WhatsApp
//               </Button>
//             </a>
//             <div className="grid grid-cols-3 gap-3 mt-5 pt-4 border-t border-slate-100">
//               {[
//                 { v: "50K+", l: "Patients Treated" },
//                 { v: "98%", l: "Success Rate" },
//                 { v: "24/7", l: "Support Available" },
//               ].map((s, i) => (
//                 <div
//                   key={i}
//                   className={`text-center ${i === 1 ? "border-x border-slate-100" : ""}`}
//                 >
//                   <div className="text-orange-500 font-bold text-lg">{s.v}</div>
//                   <div className="text-xs text-slate-500">{s.l}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </section>
// );

// // ============================================
// // HOW IT WORKS SCREEN
// // ============================================
// const HowItWorksScreen = ({ treatment }) => (
//   <section className="py-16 bg-white">
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <div className="text-center mb-14">
//         <span className="text-orange-600 font-semibold text-sm uppercase tracking-widest">
//           Step by Step
//         </span>
//         <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4">
//           How It Works
//         </h2>
//         <p className="text-slate-500 max-w-xl mx-auto text-sm">
//           From your first consultation to complete recovery, we guide you every
//           step of the way.
//         </p>
//       </div>

//       <div className="relative">
//         <div className="hidden lg:block absolute top-20 left-0 right-0 h-0.5 bg-gradient-to-r from-orange-200 via-orange-400 to-orange-200 mx-32" />
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//           {treatment.procedure.map((step, i) => {
//             const Icon = step.icon;
//             return (
//               <div
//                 key={i}
//                 className="relative flex flex-col items-center text-center group"
//               >
//                 <div className="relative z-10 mb-5">
//                   <div className="w-16 h-16 bg-orange-600 rounded-2xl flex items-center justify-center shadow-lg shadow-orange-200 group-hover:scale-110 transition-transform">
//                     <Icon className="w-7 h-7 text-white" />
//                   </div>
//                   <div className="absolute -top-2 -right-2 w-6 h-6 bg-slate-900 text-white rounded-full text-xs font-bold flex items-center justify-center">
//                     {i + 1}
//                   </div>
//                 </div>
//                 <div className="bg-slate-50 rounded-2xl p-5 w-full border border-slate-100 group-hover:border-orange-200 group-hover:shadow-md transition-all">
//                   <h3 className="font-bold text-slate-900 mb-2 text-sm">
//                     {step.title}
//                   </h3>
//                   <div className="inline-flex items-center gap-1.5 bg-orange-100 text-orange-700 rounded-full px-3 py-1 text-xs font-semibold">
//                     <Clock className="w-3 h-3" />
//                     {step.duration}
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       <div className="mt-12 bg-slate-50 rounded-3xl p-7 border border-slate-100 flex flex-col md:flex-row items-center justify-between gap-5">
//         <div className="flex items-center gap-4">
//           <div className="w-12 h-12 bg-orange-100 rounded-2xl flex items-center justify-center">
//             <MessageCircle className="w-6 h-6 text-orange-600" />
//           </div>
//           <div>
//             <div className="font-bold text-slate-900 text-sm">
//               Have questions about the procedure?
//             </div>
//             <div className="text-slate-500 text-xs">
//               Our care coordinators are available 24/7
//             </div>
//           </div>
//         </div>
//         <div className="flex flex-col sm:flex-row gap-3 shrink-0">
//           <ConsultationModal
//             trigger={
//               <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-7 py-5 font-semibold text-sm">
//                 Book Now <ArrowRight className="ml-2 h-4 w-4" />
//               </Button>
//             }
//           />
//           <a
//             href={`https://wa.me/${WHATSAPP_NUMBER}`}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <Button
//               variant="outline"
//               className="border-2 border-green-500 text-green-600 hover:bg-green-50 rounded-full px-7 py-5 font-semibold text-sm w-full sm:w-auto"
//             >
//               <MessageCircle className="w-4 h-4 mr-2 fill-green-500 text-green-500" />
//               WhatsApp Us
//             </Button>
//           </a>
//         </div>
//       </div>
//     </div>
//   </section>
// );

// // ============================================
// // TESTIMONIALS SCREEN
// // ============================================
// const TestimonialsScreen = ({ treatment }) => (
//   <section className="py-16 bg-slate-900 text-white overflow-hidden">
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <div className="text-center mb-14">
//         <span className="text-orange-400 font-semibold text-sm uppercase tracking-widest">
//           Real Stories
//         </span>
//         <h2 className="text-3xl sm:text-4xl font-bold text-white mt-3 mb-4">
//           Patient Success Stories
//         </h2>
//         <p className="text-slate-400 max-w-xl mx-auto text-sm">
//           Hear from real patients who transformed their lives with our care.
//         </p>
//       </div>

//       <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12">
//         <div className="text-center">
//           <div className="text-6xl font-bold text-white">4.9</div>
//           <div className="flex justify-center mt-2">
//             {[...Array(5)].map((_, i) => (
//               <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
//             ))}
//           </div>
//           <div className="text-slate-400 text-sm mt-1">Overall Rating</div>
//         </div>
//         <div className="w-px h-16 bg-slate-700 hidden sm:block" />
//         <div className="flex gap-8">
//           {[
//             { label: "Total Reviews", val: "3,000+" },
//             { label: "Recommend Us", val: "99%" },
//             { label: "5-Star Reviews", val: "92%" },
//           ].map((s) => (
//             <div key={s.label} className="text-center">
//               <div className="text-2xl font-bold text-orange-400">{s.val}</div>
//               <div className="text-slate-400 text-xs mt-1">{s.label}</div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="grid md:grid-cols-3 gap-5">
//         {treatment.testimonials.map((t, i) => (
//           <div
//             key={i}
//             className="bg-slate-800 rounded-3xl p-6 border border-slate-700 hover:border-orange-500/50 transition-colors"
//           >
//             <div className="text-4xl text-orange-500 font-serif leading-none mb-4">
//               "
//             </div>
//             <div className="flex mb-4">
//               {[...Array(t.rating)].map((_, j) => (
//                 <Star key={j} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
//               ))}
//             </div>
//             <p className="text-slate-300 text-sm leading-relaxed mb-5 italic">
//               {t.text}
//             </p>
//             <div className="inline-block bg-orange-500/20 text-orange-400 rounded-full px-3 py-1 text-xs font-medium mb-5">
//               {t.treatment}
//             </div>
//             <div className="flex items-center gap-3 pt-4 border-t border-slate-700">
//               <img
//                 src={t.image}
//                 alt={t.name}
//                 className="w-11 h-11 rounded-full object-cover ring-2 ring-orange-500/30"
//               />
//               <div>
//                 <div className="font-semibold text-white text-sm">{t.name}</div>
//                 <div className="text-slate-400 text-xs">
//                   Age {t.age} · {t.location} · {t.date}
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       <div className="mt-12 text-center">
//         <p className="text-slate-400 text-sm mb-5">
//           Ready to write your own success story?
//         </p>
//         <div className="flex flex-col sm:flex-row gap-4 justify-center">
//           <ConsultationModal
//             trigger={
//               <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold">
//                 Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//               </Button>
//             }
//           />
//           <a
//             href={`https://wa.me/${WHATSAPP_NUMBER}`}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <Button
//               variant="outline"
//               className="border-2 border-green-500 text-green-600 hover:bg-green-50 rounded-full px-8 py-6 font-semibold"
//             >
//               <MessageCircle className="w-4 h-4 mr-2 fill-green-500 text-green-500" />
//               Chat on WhatsApp
//             </Button>
//           </a>
//         </div>
//       </div>
//     </div>
//   </section>
// );

// // ============================================
// // FAQ SCREEN — Phone CTA removed, WhatsApp only
// // ============================================
// const FAQScreen = ({ treatment }) => {
//   const [openIdx, setOpenIdx] = useState(0);

//   return (
//     <section className="py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid lg:grid-cols-2 gap-14 items-start">
//           {/* LEFT — sticky info + CTA */}
//           <div className="lg:sticky lg:top-24">
//             <span className="text-orange-600 font-semibold text-sm uppercase tracking-widest">
//               FAQ
//             </span>
//             <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4">
//               Frequently Asked Questions
//             </h2>
//             <p className="text-slate-500 leading-relaxed mb-7 text-sm">
//               Everything you need to know about {treatment.name}. Can't find the
//               answer? We're here to help.
//             </p>

//             {/* Contact card — WhatsApp only */}
//             <div className="bg-gradient-to-br from-slate-50 to-orange-50 border border-orange-100 rounded-3xl p-6 space-y-4">
//               {/* Header */}
//               <div className="flex items-center gap-3">
//                 <div className="w-11 h-11 bg-green-100 rounded-xl flex items-center justify-center shrink-0">
//                   <MessageCircle className="w-5 h-5 text-green-600" />
//                 </div>
//                 <div>
//                   <div className="font-semibold text-slate-900 text-sm">
//                     Still have questions?
//                   </div>
//                   <div className="text-slate-500 text-xs">
//                     We're here to help
//                   </div>
//                 </div>
//               </div>

//               {/* WhatsApp CTA */}
//               <a
//                 href={`https://wa.me/${WHATSAPP_NUMBER}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="flex items-center justify-center gap-2 w-full bg-green-500 hover:bg-green-600 text-white rounded-xl py-3.5 font-semibold text-sm transition-colors shadow-md shadow-green-500/20"
//               >
//                 <MessageCircle className="w-4 h-4 fill-white" />
//                 Chat on WhatsApp
//               </a>

//               {/* Trust row */}
//               <div className="flex items-center justify-between pt-2 border-t border-orange-100">
//                 {[
//                   { icon: Timer, label: "48hr reply" },
//                   { icon: DollarSign, label: "Free advice" },
//                   { icon: Lock, label: "Confidential" },
//                 ].map((item, i) => {
//                   const Icon = item.icon;
//                   return (
//                     <div key={i} className="flex flex-col items-center gap-1">
//                       <div className="w-8 h-8 bg-white rounded-lg border border-slate-200 flex items-center justify-center shadow-sm">
//                         <Icon className="w-3.5 h-3.5 text-orange-500" />
//                       </div>
//                       <span className="text-slate-500 text-[10px] font-medium">
//                         {item.label}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* RIGHT — accordion */}
//           <div className="space-y-3">
//             {treatment.faqs.map((faq, i) => (
//               <div
//                 key={i}
//                 className={`border rounded-2xl overflow-hidden transition-all ${
//                   openIdx === i
//                     ? "border-orange-200 shadow-md"
//                     : "border-slate-200"
//                 }`}
//               >
//                 <button
//                   onClick={() => setOpenIdx(openIdx === i ? null : i)}
//                   className={`w-full flex items-center justify-between p-5 text-left transition-colors ${
//                     openIdx === i
//                       ? "bg-orange-50"
//                       : "bg-white hover:bg-slate-50"
//                   }`}
//                 >
//                   <span className="font-semibold text-slate-900 text-sm pr-4 leading-relaxed">
//                     {faq.q}
//                   </span>
//                   <div
//                     className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-colors ${
//                       openIdx === i ? "bg-orange-600" : "bg-slate-100"
//                     }`}
//                   >
//                     {openIdx === i ? (
//                       <ChevronUp className="w-4 h-4 text-white" />
//                     ) : (
//                       <ChevronDown className="w-4 h-4 text-slate-600" />
//                     )}
//                   </div>
//                 </button>
//                 {openIdx === i && (
//                   <div className="px-5 pb-5 bg-orange-50 border-t border-orange-100">
//                     <p className="text-slate-600 text-sm leading-relaxed pt-4">
//                       {faq.a}
//                     </p>
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // FREE MEDICAL REVIEW CTA SCREEN
// // ============================================
// const FreeMedicalReviewScreen = ({ treatment }) => (
//   <section className="py-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
//     <div className="absolute inset-0 overflow-hidden pointer-events-none">
//       <div className="absolute -top-40 -right-40 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl" />
//       <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-green-500/10 rounded-full blur-3xl" />
//     </div>

//     <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//       <div className="inline-flex items-center gap-2 bg-green-500/20 border border-green-500/30 text-green-400 rounded-full px-4 py-1.5 text-xs font-semibold mb-6">
//         <Sparkles className="w-3.5 h-3.5" />
//         Free · No Commitment · 48hr Response
//       </div>

//       <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
//         Ready to get a free
//         <br />
//         <span className="text-orange-400">medical review?</span>
//       </h2>

//       <p className="text-slate-300 text-base sm:text-lg leading-relaxed mb-8 max-w-2xl mx-auto">
//         Send your reports on WhatsApp. Within 48 hours, Samar personally reviews
//         your case and sends you a plain-English summary with treatment options
//         and cost estimates.{" "}
//         <span className="text-white font-semibold">
//           Zero charge. Zero commitment.
//         </span>
//       </p>

//       <a
//         href={`https://wa.me/${WHATSAPP_NUMBER}`}
//         target="_blank"
//         rel="noopener noreferrer"
//         className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-2xl px-8 py-5 font-bold text-base sm:text-lg transition-all shadow-xl shadow-green-500/25 hover:shadow-green-500/40 hover:-translate-y-0.5 mb-5"
//       >
//         <MessageCircle className="w-6 h-6 fill-white" />
//         Send Reports on WhatsApp
//       </a>

//       <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-slate-400 mb-10">
//         {[
//           "Free review",
//           "No commitment",
//           "Reply within 48 hours",
//           "Zero coordination fees",
//         ].map((item, i) => (
//           <span key={i} className="flex items-center gap-1.5">
//             <CheckCircle className="w-3.5 h-3.5 text-green-500" />
//             {item}
//           </span>
//         ))}
//       </div>

//       <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
//         {[
//           {
//             icon: FileText,
//             bg: "bg-orange-500/20",
//             border: "border-orange-500/30",
//             color: "text-orange-400",
//             label: "Upload any format",
//             sub: "PDF, image, scan",
//           },
//           {
//             icon: Timer,
//             bg: "bg-blue-500/20",
//             border: "border-blue-500/30",
//             color: "text-blue-400",
//             label: "48-hour response",
//             sub: "Personal review",
//           },
//           {
//             icon: BadgeCheck,
//             bg: "bg-violet-500/20",
//             border: "border-violet-500/30",
//             color: "text-violet-400",
//             label: "JCI & NABH",
//             sub: "Accredited hospitals",
//           },
//           {
//             icon: Globe,
//             bg: "bg-green-500/20",
//             border: "border-green-500/30",
//             color: "text-green-400",
//             label: "Visa guidance",
//             sub: "Included free",
//           },
//         ].map((card, i) => {
//           const Icon = card.icon;
//           return (
//             <div
//               key={i}
//               className={`${card.bg} border ${card.border} rounded-2xl p-4 text-center`}
//             >
//               <div
//                 className={`w-10 h-10 rounded-xl ${card.bg} flex items-center justify-center mx-auto mb-3`}
//               >
//                 <Icon className={`w-5 h-5 ${card.color}`} />
//               </div>
//               <div className="text-white font-semibold text-sm mb-0.5">
//                 {card.label}
//               </div>
//               <div className="text-slate-400 text-xs">{card.sub}</div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   </section>
// );

// // ============================================
// // FLOATING CTA (Mobile)
// // ============================================
// const FloatingCTA = () => {
//   const [visible, setVisible] = useState(false);
//   React.useEffect(() => {
//     const handleScroll = () => setVisible(window.scrollY > 400);
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);
//   if (!visible) return null;

//   return (
//     <div className="fixed bottom-0 left-0 right-0 z-30 md:hidden bg-white border-t border-slate-200 px-4 py-3 shadow-xl">
//       <div className="flex gap-3">
//         <ConsultationModal
//           trigger={
//             <Button className="flex-1 bg-orange-600 hover:bg-orange-700 text-white rounded-xl py-5 font-semibold text-sm">
//               Free Consultation
//             </Button>
//           }
//         />
//         <a
//           href={`https://wa.me/${WHATSAPP_NUMBER}`}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="flex-1"
//         >
//           <Button
//             variant="outline"
//             className="w-full border-2 border-green-500 text-green-600 rounded-xl py-5 font-semibold text-sm"
//           >
//             <MessageCircle className="w-4 h-4 mr-1.5 fill-green-500 text-green-500" />
//             WhatsApp
//           </Button>
//         </a>
//       </div>
//     </div>
//   );
// };

// // ============================================
// // MAIN PAGE
// // ============================================
// const TreatmentLandingPage = () => {
//   const { treatmentSlug } = useParams();
//   const slug = treatmentSlug || "cardiac-surgery";
//   const treatment = TREATMENTS_DATA[slug];

//   if (!treatment) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-slate-50">
//         <div className="text-center">
//           <div className="text-6xl mb-4">🔍</div>
//           <h2 className="text-2xl font-bold text-slate-900 mb-2">
//             Treatment Not Found
//           </h2>
//           <p className="text-slate-500 mb-6">
//             The treatment page you're looking for doesn't exist.
//           </p>
//           <a
//             href="/treatments"
//             className="bg-orange-600 text-white rounded-full px-8 py-3 font-semibold hover:bg-orange-700 transition-colors"
//           >
//             View All Treatments
//           </a>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-white">
//       <HeroScreen treatment={treatment} />
//       <StatsScreen treatment={treatment} />
//       <WhyIndiaScreen treatment={treatment} />
//       <ProcessScreen treatment={treatment} />
//       <ConditionsScreen treatment={treatment} />
//       <CostComparisonScreen treatment={treatment} />
//       <WhyChooseScreen treatment={treatment} />
//       <HowItWorksScreen treatment={treatment} />
//       <TestimonialsScreen treatment={treatment} />
//       <FAQScreen treatment={treatment} />
//       <FreeMedicalReviewScreen treatment={treatment} />
//       <FloatingCTA />
//     </div>
//   );
// };

// export default TreatmentLandingPage;


// import React, { useState } from "react";
// import { useParams } from "react-router-dom";
// import ConsultationModal from "@/components/ConsultationModal";
// import { Button } from "@/components/ui/button";
// import {
//   CheckCircle,
//   Clock,
//   Star,
//   Users,
//   Shield,
//   ArrowRight,
//   Phone,
//   ChevronDown,
//   ChevronUp,
//   Award,
//   Heart,
//   MapPin,
//   Mail,
//   Facebook,
//   Twitter,
//   Instagram,
//   Youtube,
//   Menu,
//   X,
//   Calendar,
//   ThumbsUp,
//   Activity,
//   Plane,
//   MessageCircle,
//   FileText,
//   Video,
//   Building2,
//   HeartPulse,
//   Microscope,
//   Stethoscope,
//   BadgeCheck,
//   Globe,
//   Timer,
//   DollarSign,
//   TrendingDown,
//   Sparkles,
//   Send,
//   Zap,
//   Lock,
//   Scissors,
//   Droplets,
// } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { Input } from "@/components/ui/input";
// import { Label } from "@/components/ui/label";
// import { Textarea } from "@/components/ui/textarea";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "@/components/ui/select";
// import { Loader2 } from "lucide-react";
// import axios from "axios";

// // ============================================
// // TREATMENTS DATA
// // ============================================
// export const TREATMENTS_DATA = {
//   "cardiac-surgery": {
//     slug: "cardiac-surgery",
//     name: "Cardiac Surgery",
//     shortName: "Heart Surgery",
//     tagline: "Protect the Heart That Powers You",
//     heroSubtag:
//       "Save 70–80% on heart surgery. World-class cardiac centres. No waiting list.",
//     description:
//       "Comprehensive cardiac care from bypass surgery to valve repair, delivered by India's leading heart surgeons using the latest minimally invasive and robotic techniques. Our centres perform over 3,000 open-heart procedures annually with outcomes that match global benchmarks.",
//     heroImage:"/PediatricCardiology.jpeg",
//     category: "Cardiology",
//     badge: "Life-Saving",
//     accentColor: "red",
//     costCard: {
//       label: "Complete cardiac package",
//       value: "₹2.5L–₹4.5L",
//       compare: "vs. ₹45L+ in the UK",
//       stay: "10–14 days hospital + 14–21 days recovery",
//       stayCompare: "vs. $40,000–$80,000 in the US",
//     },
//     stats: [
//       { label: "Success Rate", value: "97%", icon: Award },
//       { label: "Surgeries/Year", value: "3,000+", icon: Users },
//       { label: "Years Experience", value: "25+", icon: Shield },
//       { label: "ICU Recovery", value: "2-4 Days", icon: Clock },
//     ],
//     benefits: [
//       "Minimally invasive & robotic cardiac surgery options",
//       "Full spectrum: CABG, valve repair/replacement, ASD/VSD closure",
//       "24/7 cardiac catheterisation lab for emergencies",
//       "Dedicated cardiac ICU with 1:1 nurse-to-patient ratio",
//       "Integrated rehabilitation & cardiac physiotherapy",
//       "Insurance pre-authorisation support",
//       "Internationally accredited heart failure programme",
//       "Telemedicine follow-up for outstation patients",
//     ],
//     procedure: [
//       {
//         step: "01",
//         title: "Cardiac Evaluation",
//         desc: "ECG, echocardiography, coronary angiography and risk stratification.",
//         duration: "1-2 Days",
//         icon: Calendar,
//       },
//       {
//         step: "02",
//         title: "Pre-Op Optimisation",
//         desc: "Cardiology clearance, blood thinners review, anaesthesia assessment.",
//         duration: "3-5 Days",
//         icon: Activity,
//       },
//       {
//         step: "03",
//         title: "Surgery",
//         desc: "CABG, valve or structural procedure under cardiopulmonary bypass or off-pump.",
//         duration: "3-6 Hours",
//         icon: ThumbsUp,
//       },
//       {
//         step: "04",
//         title: "Cardiac Rehab",
//         desc: "Supervised exercise, diet counselling and medication optimisation.",
//         duration: "6-12 Weeks",
//         icon: Heart,
//       },
//     ],
//     faqs: [
//       {
//         q: "What is bypass surgery (CABG)?",
//         a: "Coronary Artery Bypass Grafting creates new routes for blood to flow around blocked arteries using vessels harvested from your leg, arm or chest wall.",
//       },
//       {
//         q: "How long is the hospital stay after open-heart surgery?",
//         a: "Most patients spend 2-4 days in the cardiac ICU followed by 4-6 days in a step-down ward — typically 7-10 days total.",
//       },
//       {
//         q: "Is robotic cardiac surgery safe?",
//         a: "Yes. Robotic-assisted procedures reduce blood loss, infection risk and recovery time while offering surgeons enhanced precision.",
//       },
//       {
//         q: "When can I return to work?",
//         a: "Desk workers usually return in 6-8 weeks; physically demanding jobs may require 3-4 months. Your surgeon will tailor the timeline.",
//       },
//       {
//         q: "Does insurance cover cardiac surgery?",
//         a: "Most group health policies and Ayushman Bharat cover cardiac procedures. Our insurance team assists with pre-authorisation and cashless claims.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Naresh Trehan",
//         specialty: "Cardiothoracic & Vascular Surgeon",
//         experience: "40 Years",
//         rating: 5.0,
//         reviews: 3800,
//         image: "https://randomuser.me/api/portraits/men/11.jpg",
//         qualifications: "MBBS, MS, FACC, FRCS (UK)",
//         hospital: "Medanta – The Medicity, Gurugram",
//       },
//       {
//         name: "Dr. Devi Prasad Shetty",
//         specialty: "Cardiac Surgeon",
//         experience: "35 Years",
//         rating: 4.9,
//         reviews: 4200,
//         image: "https://randomuser.me/api/portraits/men/21.jpg",
//         qualifications: "MBBS, FRCS (Glasg), FAMS",
//         hospital: "Narayana Health, Bengaluru",
//       },
//       {
//         name: "Dr. Meena Varma",
//         specialty: "Interventional Cardiologist",
//         experience: "22 Years",
//         rating: 4.8,
//         reviews: 1760,
//         image: "https://randomuser.me/api/portraits/women/31.jpg",
//         qualifications: "MBBS, MD (Cardiology), DM",
//         hospital: "Fortis Escorts, Delhi",
//       },
//     ],
//     testimonials: [
//       {
//         name: "Suresh Nair",
//         age: 58,
//         location: "Kochi",
//         text: "Triple bypass and I was walking in the corridor on day three. The cardiac team's precision and the ICU nursing staff's care were extraordinary.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/men/71.jpg",
//         treatment: "Triple CABG",
//         date: "April 2024",
//       },
//       {
//         name: "Kavita Singh",
//         age: 52,
//         location: "Lucknow",
//         text: "Mitral valve repair done robotically — no big scar, home in eight days. My cardiologist in Lucknow couldn't believe how quickly I recovered.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/women/52.jpg",
//         treatment: "Robotic Mitral Valve Repair",
//         date: "February 2024",
//       },
//       {
//         name: "Rajiv Kapoor",
//         age: 63,
//         location: "Chandigarh",
//         text: "From diagnosis to surgery in five days. The insurance team handled everything cashless. I only had to focus on getting better.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/men/48.jpg",
//         treatment: "Aortic Valve Replacement",
//         date: "March 2024",
//       },
//     ],
//   },
//   oncology: {
//     slug: "oncology",
//     name: "Cancer Treatment",
//     shortName: "Oncology",
//     tagline: "Precision Care. Real Hope.",
//     heroSubtag:
//       "Advanced cancer care at a fraction of Western costs. Personalised oncology teams. Proven outcomes.",
//     description:
//       "Comprehensive cancer care combining surgery, chemotherapy, radiation, immunotherapy and targeted therapy under one roof. Our multidisciplinary tumour boards review every case to deliver globally benchmarked, personalised treatment plans.",
//     heroImage:
//       "https://images.unsplash.com/photo-1719012577098-78efd07c5357?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDB8fG9uY29sb2d5fGVufDB8fDB8fHww",
//     category: "Oncology",
//     badge: "Comprehensive Care",
//     accentColor: "purple",
//     costCard: {
//       label: "Cancer treatment packages",
//       value: "₹3L–₹12L",
//       compare: "vs. ₹45L+ in the UK",
//       stay: "Varies by treatment: 4 weeks to 6 months for full course",
//       stayCompare: "vs. $100,000+ in the US",
//     },
//     stats: [
//       { label: "Tumour Types", value: "50+", icon: Award },
//       { label: "Patients/Year", value: "10,000+", icon: Users },
//       { label: "Years Experience", value: "25+", icon: Shield },
//       { label: "Tumour Board Review", value: "Weekly", icon: Clock },
//     ],
//     benefits: [
//       "PET-CT, liquid biopsy & molecular profiling for precise diagnosis",
//       "Robotic & laparoscopic onco-surgery",
//       "Linear accelerator (LINAC) with IMRT/IGRT/SBRT capabilities",
//       "Targeted therapy & immunotherapy infusion centre",
//       "Dedicated bone marrow transplant unit",
//       "Survivorship and palliative care programmes",
//       "Clinical trial access for novel therapies",
//       "Psychological counselling & nutritional support",
//     ],
//     procedure: [
//       {
//         step: "01",
//         title: "Diagnosis & Staging",
//         desc: "Biopsy, molecular testing, PET-CT scan and tumour board review.",
//         duration: "5-7 Days",
//         icon: Calendar,
//       },
//       {
//         step: "02",
//         title: "Treatment Planning",
//         desc: "Personalised protocol: surgery, chemo, radiation or combination.",
//         duration: "1 Week",
//         icon: Activity,
//       },
//       {
//         step: "03",
//         title: "Active Treatment",
//         desc: "Surgery, chemotherapy cycles or radiation — as planned by the board.",
//         duration: "4-24 Weeks",
//         icon: ThumbsUp,
//       },
//       {
//         step: "04",
//         title: "Survivorship & Monitoring",
//         desc: "Regular imaging, tumour markers and lifestyle support after remission.",
//         duration: "Ongoing",
//         icon: Heart,
//       },
//     ],
//     faqs: [
//       {
//         q: "What cancers do you treat?",
//         a: "We treat all major solid tumours (breast, lung, colon, prostate, cervical, liver, stomach) and blood cancers (leukaemia, lymphoma, myeloma), among 50+ tumour types.",
//       },
//       {
//         q: "What is a multidisciplinary tumour board?",
//         a: "A weekly meeting where surgeons, oncologists, radiologists, pathologists and support specialists jointly review each case to agree on the most effective personalised plan.",
//       },
//       {
//         q: "Is immunotherapy available?",
//         a: "Yes. We offer checkpoint inhibitors, CAR-T cell therapy and clinical trials for eligible patients across several cancer types.",
//       },
//       {
//         q: "How painful is chemotherapy?",
//         a: "Modern anti-nausea and supportive medications have greatly reduced side effects. Many patients continue working during treatment cycles.",
//       },
//       {
//         q: "Do you offer a second opinion?",
//         a: "Absolutely. You can upload reports for a digital second opinion from our senior oncologists within 48 hours.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Shyam Aggarwal",
//         specialty: "Medical Oncologist",
//         experience: "28 Years",
//         rating: 4.9,
//         reviews: 2100,
//         image: "https://randomuser.me/api/portraits/men/33.jpg",
//         qualifications: "MBBS, MD, DM (Oncology), MRCP",
//         hospital: "Sir Ganga Ram Hospital, Delhi",
//       },
//       {
//         name: "Dr. Reena Nair",
//         specialty: "Surgical Oncologist",
//         experience: "20 Years",
//         rating: 4.9,
//         reviews: 1540,
//         image: "https://randomuser.me/api/portraits/women/41.jpg",
//         qualifications: "MBBS, MS (Surgery), MCh (Onco)",
//         hospital: "Tata Memorial Hospital, Mumbai",
//       },
//       {
//         name: "Dr. Anand Mishra",
//         specialty: "Radiation Oncologist",
//         experience: "18 Years",
//         rating: 4.8,
//         reviews: 980,
//         image: "https://randomuser.me/api/portraits/men/61.jpg",
//         qualifications: "MBBS, MD (Radiation Oncology)",
//         hospital: "Apollo Cancer Centre, Chennai",
//       },
//     ],
//     testimonials: [
//       {
//         name: "Meena Desai",
//         age: 44,
//         location: "Ahmedabad",
//         text: "Stage 3 breast cancer, and today I am in complete remission. The tumour board ensured I got the right combination of surgery and targeted therapy from day one.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/women/62.jpg",
//         treatment: "Breast Cancer – Surgery + Chemo",
//         date: "January 2024",
//       },
//       {
//         name: "Harish Bose",
//         age: 55,
//         location: "Kolkata",
//         text: "Colon cancer caught at stage 2 thanks to their early-detection programme. Robotic surgery, no colostomy bag, back home in 10 days. Truly life-changing.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/men/75.jpg",
//         treatment: "Colorectal Cancer – Robotic Surgery",
//         date: "March 2024",
//       },
//       {
//         name: "Preethi Rajan",
//         age: 38,
//         location: "Chennai",
//         text: "The counsellors and nutritionists made chemotherapy far more bearable than I feared. I never felt alone throughout my entire treatment journey.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/women/29.jpg",
//         treatment: "Ovarian Cancer – Chemo + Immunotherapy",
//         date: "April 2024",
//       },
//     ],
//   },
//   "liposuction-tummy-tuck": {
//     slug: "liposuction-tummy-tuck",
//     name: "Liposuction with Tummy Tuck",
//     shortName: "Body Contouring",
//     tagline: "Sculpt Your Dream Silhouette",
//     heroSubtag:
//       "Save 60–75% on body contouring. World-class cosmetic surgeons. No waiting list.",
//     description:
//       "Comprehensive body contouring combining liposuction and abdominoplasty (tummy tuck) to remove stubborn fat deposits and tighten abdominal muscles. Our board-certified plastic surgeons use advanced techniques including VASER, SmartLipo, and high-definition liposculpture for natural-looking results with minimal scarring.",
//     heroImage: "https://www.istockphoto.com/search/2/image?utm_source=unsplash&utm_medium=affiliate&utm_campaign=srp_photos_zsr&utm_content=https%3A%2F%2Funsplash.com%2Fs%2Fphotos%2Fiposuction-tummy-tuck&utm_term=iposuction+tummy+tuck%3A%3A%3A%3A54496c89-efb9-4d6c-8d03-568eadadcffa&phrase=iposuction+tummy+tuck&alloweduse=availableforalluses&excludenudity=true&sort=best&mediatype=photography",
//     category: "Cosmetic Surgery",
//     badge: "Transformative",
//     accentColor: "pink",
//     costCard: {
//       label: "Complete body contouring package",
//       value: "₹1.8L–₹3.5L",
//       compare: "vs. ₹25L+ in the UK",
//       stay: "2–4 days hospital + 10–14 days recovery",
//       stayCompare: "vs. $15,000–$25,000 in the US",
//     },
//     stats: [
//       { label: "Success Rate", value: "98%", icon: Award },
//       { label: "Procedures/Year", value: "2,500+", icon: Users },
//       { label: "Years Experience", value: "20+", icon: Shield },
//       { label: "Recovery Time", value: "2 Weeks", icon: Clock },
//     ],
//     benefits: [
//       "Combined liposuction + tummy tuck for comprehensive results",
//       "Advanced VASER & SmartLipo technologies for precise fat removal",
//       "Muscle repair for diastasis recti (post-pregnancy)",
//       "Hidden incision techniques for minimal visible scarring",
//       "Board-certified plastic surgeons with international training",
//       "Customised treatment plans for individual body types",
//       "Complimentary post-operative compression garments",
//       "Telemedicine follow-up for international patients",
//     ],
//     procedure: [
//       {
//         step: "01",
//         title: "Consultation & Planning",
//         desc: "3D body imaging, medical evaluation, and personalised surgical plan.",
//         duration: "1-2 Days",
//         icon: Calendar,
//       },
//       {
//         step: "02",
//         title: "Pre-Op Preparation",
//         desc: "Lab tests, medical clearance, and pre-operative marking.",
//         duration: "1-2 Days",
//         icon: Activity,
//       },
//       {
//         step: "03",
//         title: "Surgery Day",
//         desc: "Liposuction of targeted areas followed by tummy tuck with muscle repair if needed.",
//         duration: "3-5 Hours",
//         icon: ThumbsUp,
//       },
//       {
//         step: "04",
//         title: "Recovery & Results",
//         desc: "Compression garments, drainage management, and gradual return to activities.",
//         duration: "2-6 Weeks",
//         icon: Sparkles,
//       },
//     ],
//     faqs: [
//       {
//         q: "Can liposuction and tummy tuck be done together?",
//         a: "Yes. Combining both procedures in a single surgery (often called a 'mommy makeover' component) reduces overall recovery time and cost while providing comprehensive results. Your surgeon will assess if you're a good candidate.",
//       },
//       {
//         q: "Who is an ideal candidate for this procedure?",
//         a: "Ideal candidates are near their target weight with stubborn fat deposits and loose abdominal skin — often after pregnancy or significant weight loss. Stable weight for 6+ months and good overall health are recommended.",
//       },
//       {
//         q: "What is the recovery like?",
//         a: "Most patients return to light activities within 2 weeks and full activities within 6 weeks. Compression garments are worn for 4-6 weeks. Swelling subsides gradually, with final results visible at 3-6 months.",
//       },
//       {
//         q: "Will there be visible scars?",
//         a: "Your surgeon places incisions strategically — typically low on the abdomen (bikini line) and around the belly button. Scars fade significantly over 12-18 months and are easily concealed under underwear or swimwear.",
//       },
//       {
//         q: "When can I see the final results?",
//         a: "Initial results are visible immediately, but final results develop over 3-6 months as swelling resolves and tissues settle. Most patients are delighted with their transformation at the 6-month mark.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Sunil Choudhary",
//         specialty: "Plastic & Cosmetic Surgeon",
//         experience: "25 Years",
//         rating: 4.9,
//         reviews: 2900,
//         image: "https://randomuser.me/api/portraits/men/31.jpg",
//         qualifications: "MBBS, MS, MCh (Plastic Surgery)",
//         hospital: "Artemis Hospital, Gurugram",
//       },
//       {
//         name: "Dr. Geeta Nair",
//         specialty: "Cosmetic & Reconstructive Surgeon",
//         experience: "18 Years",
//         rating: 4.8,
//         reviews: 2100,
//         image: "https://randomuser.me/api/portraits/women/41.jpg",
//         qualifications: "MBBS, MS, DNB (Plastic Surgery)",
//         hospital: "Apollo Hospitals, Chennai",
//       },
//       {
//         name: "Dr. Rohan Mehta",
//         specialty: "Body Contouring Specialist",
//         experience: "15 Years",
//         rating: 4.8,
//         reviews: 1850,
//         image: "https://randomuser.me/api/portraits/men/51.jpg",
//         qualifications: "MBBS, MS, Fellowship in Aesthetic Surgery",
//         hospital: "Fortis Hospital, Mumbai",
//       },
//     ],
//     testimonials: [
//       {
//         name: "Priya Sharma",
//         age: 34,
//         location: "Delhi",
//         text: "After two kids, I had given up on my pre-pregnancy body. The combined liposuction and tummy tuck gave me my confidence back. The surgeon was incredibly skilled and the care team was wonderful.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/women/61.jpg",
//         treatment: "Liposuction + Tummy Tuck",
//         date: "January 2024",
//       },
//       {
//         name: "Ananya Patel",
//         age: 42,
//         location: "Ahmedabad",
//         text: "I lost 40kg through diet and exercise but was left with loose skin and stubborn fat. This procedure was life-changing. The results are natural and the scarring is minimal — exactly what I wanted.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/women/72.jpg",
//         treatment: "Post-Weight Loss Body Contouring",
//         date: "March 2024",
//       },
//       {
//         name: "Neha Kapoor",
//         age: 29,
//         location: "Mumbai",
//         text: "I always struggled with my belly pooch despite being fit. The VASER liposuction with skin tightening was a game-changer. Back to my yoga classes in 3 weeks!",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/women/82.jpg",
//         treatment: "VASER Liposuction + Skin Tightening",
//         date: "November 2023",
//       },
//     ],
//   },
//   "bone-marrow-transplant": {
//     slug: "bone-marrow-transplant",
//     name: "Bone Marrow Transplant",
//     shortName: "BMT",
//     tagline: "A Second Chance at Life",
//     heroSubtag:
//       "Save 70–80% on BMT. World-class haematology centres. No waiting list for donors.",
//     description:
//       "Comprehensive bone marrow transplant services including autologous and allogeneic transplants for leukaemia, lymphoma, thalassaemia, and other blood disorders. Our centres perform over 500 transplants annually with outcomes matching leading US and European centres, supported by dedicated stem cell laboratories and 24/7 haematology intensivist coverage.",
//     heroImage: "https://images.unsplash.com/photo-1637096979782-8425e35517ab?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Ym9uZSUyMG1hcnJvd3xlbnwwfHwwfHx8MA%3D%3D",
//     category: "Haematology & Oncology",
//     badge: "Life-Saving",
//     accentColor: "red",
//     costCard: {
//       label: "Complete BMT package (autologous)",
//       value: "₹12L–₹18L",
//       compare: "vs. ₹45L+ in the UK",
//       stay: "4–6 weeks isolation + 4–8 weeks recovery",
//       stayCompare: "vs. $250,000–$500,000 in the US",
//     },
//     stats: [
//       { label: "Success Rate", value: "85%+", icon: Award },
//       { label: "Transplants/Year", value: "500+", icon: Users },
//       { label: "Years Experience", value: "25+", icon: Shield },
//       { label: "ICU Stay", value: "2-4 Weeks", icon: Clock },
//     ],
//     benefits: [
//       "Autologous & allogeneic (matched sibling, matched unrelated, haploidentical) transplants",
//       "Dedicated BMT units with HEPA filtration and positive pressure isolation rooms",
//       "Stem cell harvesting and cryopreservation on-site",
//       "24/7 haematology intensive care specialist coverage",
//       "Comprehensive pre-transplant workup and conditioning protocols",
//       "Nutritional support including parenteral nutrition when needed",
//       "Post-transplant monitoring and long-term follow-up programme",
//       "Insurance pre-authorisation and international patient support",
//     ],
//     procedure: [
//       {
//         step: "01",
//         title: "Evaluation & Workup",
//         desc: "HLA typing, disease staging, organ function tests, and donor search.",
//         duration: "2-4 Weeks",
//         icon: Calendar,
//       },
//       {
//         step: "02",
//         title: "Stem Cell Harvesting",
//         desc: "Peripheral blood stem cell collection or bone marrow harvest under anaesthesia.",
//         duration: "1-2 Days",
//         icon: Activity,
//       },
//       {
//         step: "03",
//         title: "Conditioning & Transplant",
//         desc: "Chemotherapy/radiation conditioning followed by stem cell infusion.",
//         duration: "7-10 Days",
//         icon: ThumbsUp,
//       },
//       {
//         step: "04",
//         title: "Engraftment & Recovery",
//         desc: "Neutrophil/platelet engraftment, infection prevention, and gradual recovery.",
//         duration: "4-8 Weeks",
//         icon: Heart,
//       },
//     ],
//     faqs: [
//       {
//         q: "What is the difference between autologous and allogeneic BMT?",
//         a: "Autologous transplant uses your own stem cells (harvested before high-dose chemo). Allogeneic transplant uses stem cells from a donor — usually a matched sibling or unrelated donor. The choice depends on your disease, age, and overall health.",
//       },
//       {
//         q: "How long does recovery take after BMT?",
//         a: "Hospital stay is typically 4-6 weeks for isolation and monitoring. Full immune recovery takes 6-12 months. Most patients return to normal activities within 3-6 months, but regular follow-up is essential for at least 2 years.",
//       },
//       {
//         q: "What are the success rates for BMT in India?",
//         a: "Success rates vary by disease and transplant type. For autologous transplants in multiple myeloma, 5-year survival exceeds 80%. For allogeneic transplants in leukaemia, 5-year survival ranges from 50-70% — comparable to leading Western centres.",
//       },
//       {
//         q: "Can international patients find matching donors in India?",
//         a: "Yes. India has a large and diverse stem cell donor registry. For patients requiring haploidentical (half-matched) transplants, India's large population often yields suitable family donors. We also coordinate with international registries when needed.",
//       },
//       {
//         q: "What support is available for international patients?",
//         a: "PaxGrow provides complete support including visa assistance, airport pickup, accommodation near the hospital for accompanying family, translation services, daily updates to family back home, and telemedicine follow-up after returning home.",
//       },
//     ],
//     doctors: [
//       {
//         name: "Dr. Punit Jain",
//         specialty: "Haematologist & BMT Physician",
//         experience: "22 Years",
//         rating: 4.9,
//         reviews: 1800,
//         image: "https://randomuser.me/api/portraits/men/41.jpg",
//         qualifications: "MBBS, MD, DM (Clinical Haematology)",
//         hospital: "Apollo Hospitals, Chennai",
//       },
//       {
//         name: "Dr. Reena Nair",
//         specialty: "Haematologist & BMT Specialist",
//         experience: "28 Years",
//         rating: 4.9,
//         reviews: 2200,
//         image: "https://randomuser.me/api/portraits/women/51.jpg",
//         qualifications: "MBBS, MD, FRCP (Glasg)",
//         hospital: "Tata Medical Center, Kolkata",
//       },
//       {
//         name: "Dr. Manoj Kumar",
//         specialty: "Paediatric Haematologist & BMT Physician",
//         experience: "18 Years",
//         rating: 4.8,
//         reviews: 1600,
//         image: "https://randomuser.me/api/portraits/men/61.jpg",
//         qualifications: "MBBS, MD, DM (Paediatric Haematology-Oncology)",
//         hospital: "Fortis Memorial Research Institute, Gurugram",
//       },
//     ],
//     testimonials: [
//       {
//         name: "Ahmed Hassan",
//         age: 45,
//         location: "Nairobi, Kenya",
//         text: "Diagnosed with multiple myeloma. My doctors back home said BMT was my best chance but the cost was prohibitive. PaxGrow arranged everything — from evaluation to transplant and follow-up. Today I'm in remission. Grateful beyond words.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/men/71.jpg",
//         treatment: "Autologous BMT for Multiple Myeloma",
//         date: "October 2023",
//       },
//       {
//         name: "Fatima Begum",
//         age: 32,
//         location: "Dhaka, Bangladesh",
//         text: "My 6-year-old daughter needed a bone marrow transplant for thalassaemia. The team found a matched unrelated donor and the transplant was successful. The care during isolation was exceptional. We never felt alone.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/women/62.jpg",
//         treatment: "Allogeneic BMT for Thalassaemia",
//         date: "February 2024",
//       },
//       {
//         name: "Michael Okafor",
//         age: 38,
//         location: "Lagos, Nigeria",
//         text: "Four rounds of chemotherapy failed to control my lymphoma. The allogeneic transplant was intense, but the medical team supported me through every complication. One year post-transplant, I'm cancer-free and back to work.",
//         rating: 5,
//         image: "https://randomuser.me/api/portraits/men/81.jpg",
//         treatment: "Allogeneic BMT for Lymphoma",
//         date: "June 2023",
//       },
//     ],
//   },
// };

// // ============================================
// // PAXGROW EXTRA DATA
// // ============================================
// const PAXGROW_DATA = {
//   oncology: {
//     whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//     whyIndiaTitle: "Why African Patients Choose India",
//     whyIndiaReasons: [
//       "NABH-accredited oncology departments with PET-CT, Da Vinci robotic surgery, CyberKnife",
//       "Multidisciplinary tumour boards review every case within 48 hours of arrival",
//       "Treatment begins within 7 days — critical for aggressive cancers",
//       "Tata Memorial, AIIMS, Apollo, Fortis, Max — global oncology rankings",
//     ],
//     conditionsTitle: "Cancer Treatment Conditions We Facilitate",
//     conditions: [
//       "Breast Cancer",
//       "Lung Cancer",
//       "Prostate Cancer",
//       "Blood Cancers (Leukaemia, Lymphoma)",
//       "Colorectal Cancer",
//       "Cervical Cancer",
//       "Head & Neck Cancer",
//       "Paediatric Oncology"

//     ],
//     stayValue: "Varies by treatment: 4 weeks to 6 months for full course",
//     costTitle: "Why India for Cancer Treatment?",
//     costRows: [
//       {
//         procedure: "Chemotherapy (per cycle)",
//         india: "₹25,000–₹80,000",
//         africa: "$2,000–$6,000",
//         ukusa: "$10,000–$30,000",
//       },
//       {
//         procedure: "Radiation Therapy (full course)",
//         india: "₹2.5L–₹5L",
//         africa: "$25,000–$50,000",
//         ukusa: "$80,000–$150,000",
//       },
//       {
//         procedure: "Bone Marrow Transplant",
//         india: "₹12L–₹25L",
//         africa: "Largely unavailable",
//         ukusa: "$150,000–$300,000",
//       },
//     ],
//   },
//   "cardiac-surgery": {
//     whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//     whyIndiaTitle: "Why African Patients Choose India",
//     whyIndiaReasons: [
//       "India's cardiac success rates: 97–99% for CABG at top-tier hospitals",
//       "No waiting lists — surgery within 7–14 days of arrival",
//       "Surgeons trained at Cleveland Clinic, Mayo Clinic, and UK NHS",
//       "Apollo, Fortis, Medanta, Max — all NABH and JCI accredited",
//     ],
//     conditionsTitle: "Cardiac Surgery Conditions We Facilitate",
//     conditions: [
//       "Coronary Artery Bypass Graft (CABG)",
//       "Heart Valve Replacement / Repair",
//       "Angioplasty & Stenting",
//       "Pacemaker Implantation",
//       "Atrial Septal Defect (ASD) Repair",
//       "Congenital Heart Disease Surgery",
//       "Paediatric Cardiology"
//     ],
//     stayValue: "10–14 days hospital + 14–21 days recovery",
//     costTitle: "Why India for Cardiac Surgery?",
//     costRows: [
//       {
//         procedure: "CABG (Heart Bypass)",
//         india: "₹2.5L – ₹3.8L",
//         africa: "$18,000–$25,000",
//         ukusa: "$40,000–$80,000",
//       },
//       {
//         procedure: "Heart Valve Replacement",
//         india: "₹2.8L – ₹4.2L",
//         africa: "$20,000–$28,000",
//         ukusa: "$50,000–$100,000",
//       },
//       {
//         procedure: "Angioplasty / Stenting",
//         india: "₹1.2L – ₹2.5L",
//         africa: "$10,000–$18,000",
//         ukusa: "$25,000–$50,000",
//       },
//     ],
//   },
//   "liposuction-tummy-tuck": {
//     whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//     whyIndiaTitle: "Why International Patients Choose India for Cosmetic Surgery",
//     whyIndiaReasons: [
//       "World-class plastic surgeons trained at American & European centres",
//       "NABH & JCI accredited hospitals with state-of-the-art facilities",
//       "Cost savings of 60–75% compared to Western countries",
//       "No waiting lists — surgery within 7–10 days of arrival",
//     ],
//     conditionsTitle: "Body Contouring Procedures We Facilitate",
//     conditions: [
//       "Liposuction (VASER, SmartLipo, Tumescent)",
//       "Abdominoplasty (Tummy Tuck)",
//       "Mommy Makeover (Combined Procedures)",
//       "High-Definition Liposculpture",
//       "Post-Weight Loss Body Contouring",
//       "Arm Lift (Brachioplasty)",
//       "Thigh Lift",
//       "Body Lift",
//     ],
//     stayValue: "2–4 days hospital + 10–14 days recovery (28 total days for best results)",
//     costTitle: "Why India for Body Contouring?",
//     costRows: [
//       {
//         procedure: "Liposuction (3 areas)",
//         india: "₹80K – ₹1.5L",
//         africa: "$5,000–$8,000",
//         ukusa: "$8,000–$15,000",
//       },
//       {
//         procedure: "Tummy Tuck (Full Abdominoplasty)",
//         india: "₹1.2L – ₹2.5L",
//         africa: "$7,000–$12,000",
//         ukusa: "$12,000–$20,000",
//       },
//       {
//         procedure: "Liposuction + Tummy Tuck Combo",
//         india: "₹1.8L – ₹3.5L",
//         africa: "$10,000–$18,000",
//         ukusa: "$18,000–$30,000",
//       },
//     ],
//   },
//   "bone-marrow-transplant": {
//     whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//     whyIndiaTitle: "Why International Patients Choose India for BMT",
//     whyIndiaReasons: [
//       "India performs 2,500+ BMTs annually with outcomes matching Western centres",
//       "JCI/NABH accredited BMT units with dedicated isolation facilities",
//       "Haematologists trained at leading US and UK transplant centres",
//       "Cost savings of 70–80% including donor search and stem cell processing",
//     ],
//     conditionsTitle: "Conditions Treated with Bone Marrow Transplant",
//     conditions: [
//       "Acute Leukaemia (AML, ALL)",
//       "Chronic Leukaemia (CML, CLL)",
//       "Lymphoma (Hodgkin & Non-Hodgkin)",
//       "Multiple Myeloma",
//       "Thalassaemia Major",
//       "Sickle Cell Disease",
//       "Aplastic Anaemia",
//       "Myelodysplastic Syndrome (MDS)",
//       "Severe Combined Immunodeficiency (SCID)",
//       "Autoimmune Disorders (selected cases)",
//     ],
//     stayValue: "4–6 weeks hospital + 4–8 weeks recovery in India (total 8–14 weeks recommended)",
//     costTitle: "Why India for Bone Marrow Transplant?",
//     costRows: [
//       {
//         procedure: "Autologous BMT (including stem cell harvest)",
//         india: "₹12L – ₹18L",
//         africa: "$35,000–$60,000",
//         ukusa: "$150,000–$300,000",
//       },
//       {
//         procedure: "Allogeneic BMT (matched sibling donor)",
//         india: "₹15L – ₹22L",
//         africa: "$45,000–$75,000",
//         ukusa: "$250,000–$500,000",
//       },
//       {
//         procedure: "Allogeneic BMT (matched unrelated donor)",
//         india: "₹18L – ₹28L",
//         africa: "$55,000–$100,000",
//         ukusa: "$300,000–$600,000",
//       },
//     ],
//   },
// };

// const PROCESS_STEPS = [
//   {
//     num: 1,
//     title: "Send your reports — free review",
//     desc: "WhatsApp your medical reports to PaxGrow. Within 48 hours, Samar personally sends a written summary: condition, treatment options, cost estimate, and recommended hospital. No charge. No commitment.",
//     icon: FileText,
//     color: "from-orange-400 to-orange-600",
//     iconBg: "bg-orange-100",
//     iconColor: "text-orange-600",
//   },
//   {
//     num: 2,
//     title: "Free video consultation with your surgeon",
//     desc: "PaxGrow arranges a direct video call between you and your treating specialist in India. You speak to the surgeon before committing to anything. Formal treatment plan and cost estimate provided in writing.",
//     icon: Video,
//     color: "from-blue-400 to-blue-600",
//     iconBg: "bg-blue-100",
//     iconColor: "text-blue-600",
//   },
//   {
//     num: 3,
//     title: "Visa, flights, and accommodation arranged",
//     desc: "PaxGrow provides your hospital visa invitation letter within 3 days of confirming your case. We guide you through the e-Medical Visa process (Kenya: 24–72hrs), and arrange accommodation near your hospital.",
//     icon: Plane,
//     color: "from-violet-400 to-violet-600",
//     iconBg: "bg-violet-100",
//     iconColor: "text-violet-600",
//   },
//   {
//     num: 4,
//     title: "Airport pickup and full in-hospital support",
//     desc: "PaxGrow coordinator meets you at the airport, accompanies you to the hospital, and is available throughout your stay. Translation, daily updates to family at home, and discharge documentation all handled.",
//     icon: Building2,
//     color: "from-green-400 to-green-600",
//     iconBg: "bg-green-100",
//     iconColor: "text-green-600",
//   },
//   {
//     num: 5,
//     title: "90-day follow-up after you return home",
//     desc: "PaxGrow maintains contact for 90 days after your return. Two telemedicine follow-up sessions with your Indian surgeon are included. If anything concerns you, we connect you with your treating team immediately.",
//     icon: HeartPulse,
//     color: "from-rose-400 to-rose-600",
//     iconBg: "bg-rose-100",
//     iconColor: "text-rose-600",
//   },
// ];

// // ============================================
// // WHATSAPP NUMBER
// // ============================================
// const WHATSAPP_NUMBER = "917289007800";

// // ============================================
// // API
// // ============================================
// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const treatmentOptions = [
//   "Cardiology",
//   "Orthopedics",
//   "Oncology",
//   "Neurology & Spine",
//   "Organ Transplant",
//   "Dental Care",
//   "Skin Care & Dermatology",
//   "Cosmetic Surgery",
//   "IVF & Fertility",
//   "Bariatric Surgery",
//   "Eye Care",
//   "ENT & Cochlear",
//   "Ayurveda & Wellness",
//   "Hair Transplant",
//   "Other",
// ];

// const countries = [
//   "Afghanistan",
//   "Bahrain",
//   "Bangladesh",
//   "Cameroon",
//   "Egypt",
//   "Ethiopia",
//   "Ghana",
//   "India",
//   "Indonesia",
//   "Iraq",
//   "Kenya",
//   "Kuwait",
//   "Malaysia",
//   "Mauritius",
//   "Nigeria",
//   "Oman",
//   "Pakistan",
//   "Qatar",
//   "Rwanda",
//   "Saudi Arabia",
//   "Singapore",
//   "Somalia",
//   "South Africa",
//   "Sri Lanka",
//   "Sudan",
//   "Tanzania",
//   "Thailand",
//   "UAE",
//   "Uganda",
//   "UK",
//   "USA",
//   "Vietnam",
//   "Yemen",
//   "Zambia",
//   "Zimbabwe",
//   "Other",
// ];

// // ============================================
// // SCREEN 1 — HERO
// // ============================================
// const HeroScreen = ({ treatment }) => {
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     country: "",
//     treatment: treatment.name || "",
//     message: "",
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       await axios.post(`${API}/consultations`, form);
//       const whatsappMessage = encodeURIComponent(
//         `Hi, I just submitted a consultation request.\n\nName: ${form.name}\nPhone: ${form.phone}\nTreatment: ${form.treatment}\nCountry: ${form.country}`
//       );
//       const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${whatsappMessage}`;
//       navigate("/thank-you", { state: { formData: form, whatsappUrl } });
//     } catch (err) {
//       console.error(err);
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="relative min-h-screen flex items-center bg-slate-900 overflow-hidden">
//       {/* Background */}
//       <div
//         className="absolute inset-0 bg-cover bg-center"
//         style={{ backgroundImage: `url(${treatment.heroImage})` }}
//       />
//       <div className="absolute inset-0 bg-gradient-to-r from-slate-900/97 via-slate-900/85 to-slate-900/50" />

//       {/* Decorative orbs */}
//       <div className="absolute top-20 right-10 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl pointer-events-none" />
//       <div className="absolute bottom-20 left-10 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />

//       <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 w-full">
//         <div className="grid lg:grid-cols-2 gap-10 items-start">
//           {/* LEFT COLUMN */}
//           <div className="lg:sticky lg:top-20">
//             {/* Category badge */}
//             <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/30 text-orange-300 rounded-full px-4 py-1.5 text-xs font-semibold mb-5">
//               <Award className="w-3.5 h-3.5" />
//               {treatment.category} · {treatment.badge}
//             </div>

//             <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-3">
//               {treatment.name}
//             </h1>
//             <p className="text-xl text-orange-400 font-semibold mb-3">
//               {treatment.tagline}
//             </p>

//             {/* Savings strip */}
//             <div className="inline-flex items-center gap-2 bg-green-500/15 border border-green-500/30 text-white rounded-xl px-4 py-2.5 text-sm font-medium mb-5">
//               <TrendingDown className="w-4 h-4 text-white shrink-0" />
//               {treatment.heroSubtag}
//             </div>

//             <p className="text-slate-300 text-sm leading-relaxed mb-6 max-w-lg">
//               {treatment.description}
//             </p>

//             {/* Key stats */}
//             <div className="flex flex-wrap gap-6 mb-6">
//               {treatment.stats.slice(0, 2).map((stat, i) => (
//                 <div key={i} className="text-white">
//                   <div className="text-2xl font-bold text-orange-400">
//                     {stat.value}
//                   </div>
//                   <div className="text-xs text-slate-400">{stat.label}</div>
//                 </div>
//               ))}
//             </div>

//             {/* Primary WhatsApp CTA */}
//             <a
//               href={`https://wa.me/${WHATSAPP_NUMBER}`}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-full px-7 py-4 font-semibold text-sm transition-all shadow-lg shadow-green-500/30 hover:shadow-green-500/50 hover:-translate-y-0.5 mb-6"
//             >
//               <MessageCircle className="w-5 h-5 fill-white" />
//               Send Reports — Free 48hr Review
//             </a>

//             {/* Trust icons */}
//             <div className="grid grid-cols-2 gap-2 mb-6 max-w-xs">
//               {[
//                 {
//                   icon: DollarSign,
//                   label: "Zero coordination fees",
//                   color: "text-green-400",
//                 },
//                 {
//                   icon: Timer,
//                   label: "Reply within 48 hours",
//                   color: "text-blue-400",
//                 },
//                 {
//                   icon: BadgeCheck,
//                   label: "JCI & NABH hospitals",
//                   color: "text-violet-400",
//                 },
//                 {
//                   icon: Plane,
//                   label: "Visa guidance included",
//                   color: "text-orange-400",
//                 },
//               ].map((b, i) => (
//                 <div key={i} className="flex items-center gap-2">
//                   <b.icon className={`w-3.5 h-3.5 shrink-0 ${b.color}`} />
//                   <span className="text-slate-300 text-xs">{b.label}</span>
//                 </div>
//               ))}
//             </div>

//             {/* Cost card */}
//             {treatment.costCard && (
//               <div className="bg-white/10 backdrop-blur border border-white/20 rounded-2xl p-4 max-w-xs">
//                 <div className="flex items-center gap-2 mb-2">
//                   <div className="w-7 h-7 bg-orange-500/20 rounded-lg flex items-center justify-center">
//                     <TrendingDown className="w-3.5 h-3.5 text-orange-400" />
//                   </div>
//                   <span className="text-white/60 text-xs font-medium">
//                     {treatment.costCard.label}
//                   </span>
//                 </div>
//                 <div className="text-2xl font-bold text-orange-400 leading-none mb-1">
//                   {treatment.costCard.value}
//                 </div>
//                 <div className="text-white/40 text-xs">
//                   {treatment.costCard.compare}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* RIGHT COLUMN — FORM */}
//           <div className="lg:sticky lg:top-20">
//             <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
//               {/* Form header */}
//               <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-5 text-white">
//                 <div className="flex items-center gap-3 mb-2">
//                   <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
//                     <FileText className="w-5 h-5 text-white" />
//                   </div>
//                   <div>
//                     <h3 className="font-bold text-xl">Free Consultation</h3>
//                     <p className="text-orange-100 text-xs">
//                       Expert advice · No commitment · 48hr reply
//                     </p>
//                   </div>
//                 </div>
//                 {/* Social proof strip */}
//                 <div className="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2 mt-2">
//                   <div className="flex -space-x-2">
//                     {["men/11", "women/31", "men/21"].map((p, i) => (
//                       <img
//                         key={i}
//                         src={`https://randomuser.me/api/portraits/${p}.jpg`}
//                         alt=""
//                         className="w-6 h-6 rounded-full border-2 border-orange-500 object-cover"
//                       />
//                     ))}
//                   </div>
//                   <span className="text-orange-100 text-xs">
//                     <strong className="text-white">127 patients</strong>{" "}
//                     consulted this week
//                   </span>
//                 </div>
//               </div>

//               <div className="p-6">
//                 <form onSubmit={handleSubmit} className="space-y-4">
//                   <div>
//                     <Label className="text-slate-700 text-sm font-semibold">
//                       Full Name *
//                     </Label>
//                     <Input
//                       required
//                       value={form.name}
//                       onChange={(e) =>
//                         setForm({ ...form, name: e.target.value })
//                       }
//                       placeholder="Your full name"
//                       className="mt-1 rounded-xl border-slate-200 focus:border-orange-400 focus:ring-orange-400"
//                     />
//                   </div>
//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                     <div>
//                       <Label className="text-slate-700 text-sm font-semibold">
//                         Email *
//                       </Label>
//                       <Input
//                         type="email"
//                         required
//                         value={form.email}
//                         onChange={(e) =>
//                           setForm({ ...form, email: e.target.value })
//                         }
//                         placeholder="your@email.com"
//                         className="mt-1 rounded-xl border-slate-200 focus:border-orange-400"
//                       />
//                     </div>
//                     <div>
//                       <Label className="text-slate-700 text-sm font-semibold">
//                         Phone *
//                       </Label>
//                       <Input
//                         required
//                         value={form.phone}
//                         onChange={(e) =>
//                           setForm({ ...form, phone: e.target.value })
//                         }
//                         placeholder="+1 234 567 890"
//                         className="mt-1 rounded-xl border-slate-200 focus:border-orange-400"
//                       />
//                     </div>
//                   </div>
//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                     <div>
//                       <Label className="text-slate-700 text-sm font-semibold">
//                         Country *
//                       </Label>
//                       <Select
//                         onValueChange={(v) =>
//                           setForm({ ...form, country: v })
//                         }
//                       >
//                         <SelectTrigger className="mt-1 rounded-xl border-slate-200">
//                           <SelectValue placeholder="Select country" />
//                         </SelectTrigger>
//                         <SelectContent>
//                           {countries.map((c) => (
//                             <SelectItem key={c} value={c}>
//                               {c}
//                             </SelectItem>
//                           ))}
//                         </SelectContent>
//                       </Select>
//                     </div>
//                     <div>
//                       <Label className="text-slate-700 text-sm font-semibold">
//                         Treatment *
//                       </Label>
//                       <Select
//                         value={form.treatment}
//                         onValueChange={(v) =>
//                           setForm({ ...form, treatment: v })
//                         }
//                       >
//                         <SelectTrigger className="mt-1 rounded-xl border-slate-200">
//                           <SelectValue placeholder="Select treatment" />
//                         </SelectTrigger>
//                         <SelectContent>
//                           {treatmentOptions.map((t) => (
//                             <SelectItem key={t} value={t}>
//                               {t}
//                             </SelectItem>
//                           ))}
//                         </SelectContent>
//                       </Select>
//                     </div>
//                   </div>
//                   <div>
//                     <Label className="text-slate-700 text-sm font-semibold">
//                       Medical Details{" "}
//                       <span className="text-slate-400 font-normal">
//                         (Optional)
//                       </span>
//                     </Label>
//                     <Textarea
//                       value={form.message}
//                       onChange={(e) =>
//                         setForm({ ...form, message: e.target.value })
//                       }
//                       placeholder="Briefly describe your condition or attach reports later on WhatsApp..."
//                       rows={3}
//                       className="mt-1 rounded-xl border-slate-200 focus:border-orange-400"
//                     />
//                   </div>
//                   <Button
//                     type="submit"
//                     disabled={loading}
//                     className="w-full bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-bold h-12 shadow-md shadow-orange-200 text-sm"
//                   >
//                     {loading ? (
//                       <Loader2 className="h-4 w-4 animate-spin mr-2" />
//                     ) : (
//                       <Send className="h-4 w-4 mr-2" />
//                     )}
//                     {loading ? "Submitting..." : "Get My Free Consultation"}
//                   </Button>

//                   {/* Trust line */}
//                   <div className="flex items-center justify-center gap-4 pt-1">
//                     <span className="flex items-center gap-1.5 text-xs text-slate-400">
//                       <Lock className="w-3 h-3 text-slate-400" />
//                       100% Confidential
//                     </span>
//                     <span className="text-slate-200">·</span>
//                     <span className="flex items-center gap-1.5 text-xs text-slate-400">
//                       <Zap className="w-3 h-3 text-slate-400" />
//                       Reply in 48hrs
//                     </span>
//                     <span className="text-slate-200">·</span>
//                     <span className="flex items-center gap-1.5 text-xs text-slate-400">
//                       <DollarSign className="w-3 h-3 text-slate-400" />
//                       Zero Fees
//                     </span>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Scroll hint */}
//       <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40">
//         <span className="text-xs">Scroll to explore</span>
//         <div className="w-5 h-8 border border-white/20 rounded-full flex items-start justify-center p-1">
//           <div className="w-1 h-2 bg-white/40 rounded-full animate-bounce" />
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // SCREEN 2 — STATS
// // ============================================
// const StatsScreen = ({ treatment }) => {
//   const statStyles = [
//     {
//       bg: "bg-orange-50",
//       border: "border-orange-200",
//       iconBg: "bg-orange-100",
//       val: "text-orange-700",
//       icon: "text-orange-600",
//     },
//     {
//       bg: "bg-blue-50",
//       border: "border-blue-200",
//       iconBg: "bg-blue-100",
//       val: "text-blue-700",
//       icon: "text-blue-600",
//     },
//     {
//       bg: "bg-violet-50",
//       border: "border-violet-200",
//       iconBg: "bg-violet-100",
//       val: "text-violet-700",
//       icon: "text-violet-600",
//     },
//     {
//       bg: "bg-green-50",
//       border: "border-green-200",
//       iconBg: "bg-green-100",
//       val: "text-green-700",
//       icon: "text-green-600",
//     },
//   ];

//   return (
//     <section className="py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-10">
//           <span className="text-orange-600 font-medium text-xs uppercase tracking-widest">
//             Our track record
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 mb-2 leading-tight">
//             Numbers that speak for themselves
//           </h2>
//           <p className="text-slate-500 text-sm max-w-md mx-auto leading-relaxed">
//             Two decades of clinical excellence trusted by patients across every
//             corner of India.
//           </p>
//         </div>

//         <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
//           {treatment.stats.map((stat, i) => {
//             const Icon = stat.icon;
//             const s = statStyles[i];
//             return (
//               <div
//                 key={i}
//                 className={`relative overflow-hidden rounded-2xl border ${s.bg} ${s.border} p-6 text-center hover:-translate-y-1 hover:shadow-lg transition-all duration-200`}
//               >
//                 <div
//                   className={`absolute -top-5 -right-5 w-20 h-20 rounded-full ${s.iconBg} opacity-40`}
//                 />
//                 <div
//                   className={`relative z-10 w-12 h-12 ${s.iconBg} rounded-xl flex items-center justify-center mx-auto mb-4`}
//                 >
//                   <Icon className={`w-5 h-5 ${s.icon}`} />
//                 </div>
//                 <div
//                   className={`relative z-10 text-3xl sm:text-4xl font-bold ${s.val} mb-1.5 leading-none`}
//                 >
//                   {stat.value}
//                 </div>
//                 <div className="relative z-10 text-slate-500 text-xs font-medium">
//                   {stat.label}
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         <div className="bg-slate-900 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
//           <div className="flex-1">
//             <h3 className="text-xl font-bold text-white mb-2">
//               India's most trusted medical centre
//             </h3>
//             <p className="text-slate-400 text-sm">
//               Setting the standard in patient outcomes since 2016.
//             </p>
//           </div>
//           <div className="hidden md:block w-px self-stretch bg-white/10" />
//           <div className="flex gap-8 shrink-0">
//             {[
//               { val: "50+", lbl: "Hospitals" },
//               { val: "25+", lbl: "Cities" },
//               { val: "30+", lbl: "Awards" },
//             ].map((s) => (
//               <div key={s.lbl} className="text-center">
//                 <div className="text-3xl font-bold text-orange-400">
//                   {s.val}
//                 </div>
//                 <div className="text-slate-500 text-xs mt-1">{s.lbl}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // WHY INDIA SCREEN
// // ============================================
// const WhyIndiaScreen = ({ treatment }) => {
//   const data = PAXGROW_DATA[treatment.slug];
//   if (!data) return null;

//   return (
//     <section className="py-16 bg-slate-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">
//             {data.whyIndiaSubtitle}
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4 leading-tight">
//             {data.whyIndiaTitle}
//           </h2>
//           <p className="text-slate-500 text-sm max-w-lg mx-auto">
//             Top-tier hospitals. No waiting lists. Expert surgeons. At a fraction
//             of Western costs.
//           </p>
//         </div>

//         <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
//           {[
//             {
//               icon: Microscope,
//               color: "bg-orange-100 text-orange-600",
//               border: "border-orange-200",
//             },
//             {
//               icon: Stethoscope,
//               color: "bg-blue-100 text-blue-600",
//               border: "border-blue-200",
//             },
//             {
//               icon: Timer,
//               color: "bg-violet-100 text-violet-600",
//               border: "border-violet-200",
//             },
//             {
//               icon: Globe,
//               color: "bg-green-100 text-green-600",
//               border: "border-green-200",
//             },
//           ].map((style, i) => {
//             const Icon = style.icon;
//             return (
//               <div
//                 key={i}
//                 className={`bg-white rounded-2xl border ${style.border} p-6 hover:shadow-md transition-all`}
//               >
//                 <div
//                   className={`w-11 h-11 rounded-xl ${style.color} flex items-center justify-center mb-4`}
//                 >
//                   <Icon className="w-5 h-5" />
//                 </div>
//                 <p className="text-slate-700 text-sm font-medium leading-relaxed">
//                   {data.whyIndiaReasons[i]}
//                 </p>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // PROCESS SCREEN
// // ============================================
// const ProcessScreen = ({ treatment }) => {
//   const data = PAXGROW_DATA[treatment.slug];
//   if (!data) return null;

//   return (
//     <section className="py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">
//             THE PROCESS
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4 leading-tight">
//             From First WhatsApp
//             <br />
//             to Safe Return Home
//           </h2>
//           <p className="text-slate-500 text-sm max-w-md mx-auto">
//             PaxGrow manages every step so you can focus entirely on getting
//             better.
//           </p>
//         </div>

//         {/* Timeline */}
//         <div className="relative max-w-3xl mx-auto">
//           <div className="absolute left-6 top-6 bottom-6 w-0.5 bg-gradient-to-b from-orange-300 via-violet-300 to-rose-300 hidden sm:block" />
//           <div className="space-y-6">
//             {PROCESS_STEPS.map((step) => {
//               const Icon = step.icon;
//               return (
//                 <div key={step.num} className="relative flex gap-5 sm:gap-8">
//                   <div className="relative z-10 shrink-0">
//                     <div
//                       className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${step.color} flex items-center justify-center shadow-lg`}
//                     >
//                       <Icon className="w-5 h-5 text-white" />
//                     </div>
//                     <div className="absolute -top-1 -right-1 w-5 h-5 bg-slate-900 text-white rounded-full text-[10px] font-bold flex items-center justify-center">
//                       {step.num}
//                     </div>
//                   </div>
//                   <div className="flex-1 bg-slate-50 border border-slate-100 rounded-2xl p-5 hover:border-orange-200 hover:shadow-sm transition-all">
//                     <h3 className="font-semibold text-slate-900 text-sm mb-2">
//                       {step.title}
//                     </h3>
//                     <p className="text-slate-500 text-xs leading-relaxed">
//                       {step.desc}
//                     </p>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>

//         {/* CTA */}
//         <div className="mt-10 text-center">
//           <a
//             href={`https://wa.me/${WHATSAPP_NUMBER}`}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-full px-8 py-4 font-semibold text-sm transition-all shadow-lg shadow-green-500/20"
//           >
//             <MessageCircle className="w-5 h-5 fill-white" />
//             Start with Step 1 — Send Your Reports
//           </a>
//           <p className="text-slate-400 text-xs mt-3">
//             Free review · No commitment · Reply within 48 hours
//           </p>
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // CONDITIONS SCREEN
// // ============================================
// const ConditionsScreen = ({ treatment }) => {
//   const data = PAXGROW_DATA[treatment.slug];
//   if (!data) return null;
//   const half = Math.ceil(data.conditions.length / 2);
//   const col1 = data.conditions.slice(0, half);
//   const col2 = data.conditions.slice(half);

//   return (
//     <section className="py-16 bg-slate-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="mb-8">
//           <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">
//             WHAT WE TREAT
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 leading-tight">
//             {data.conditionsTitle}
//           </h2>
//         </div>
//         <div className="grid md:grid-cols-2 gap-0 border border-slate-200 rounded-2xl overflow-hidden mb-5 bg-white">
//           {[col1, col2].map((col, ci) =>
//             col.map((cond, ri) => (
//               <div
//                 key={`${ci}-${ri}`}
//                 className={`flex items-center gap-3 px-6 py-4 hover:bg-orange-50 transition-colors
//                   ${ri < col.length - 1 ? "border-b border-slate-100" : ""}
//                   ${ci === 0 ? "md:border-r border-slate-100" : ""}
//                 `}
//               >
//                 <div className="w-7 h-7 bg-orange-100 rounded-lg flex items-center justify-center shrink-0">
//                   <ArrowRight className="w-3.5 h-3.5 text-orange-500" />
//                 </div>
//                 <span className="text-slate-700 text-sm font-medium">
//                   {cond}
//                 </span>
//               </div>
//             ))
//           )}
//         </div>
//         <div className="flex items-center gap-4 bg-gradient-to-r from-orange-50 to-amber-50 border border-orange-200 rounded-2xl px-6 py-5">
//           <div className="w-11 h-11 rounded-xl bg-orange-500 flex items-center justify-center shrink-0">
//             <Plane className="w-5 h-5 text-white" />
//           </div>
//           <div>
//             <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">
//               Typical India Stay
//             </span>
//             <p className="text-slate-700 font-semibold text-sm mt-0.5">
//               {data.stayValue}
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // COST COMPARISON SCREEN
// // ============================================
// const CostComparisonScreen = ({ treatment }) => {
//   const data = PAXGROW_DATA[treatment.slug];
//   if (!data) return null;

//   return (
//     <section className="py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="mb-8">
//           <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">
//             COST COMPARISON
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 leading-tight">
//             {data.costTitle}
//           </h2>
//         </div>

//         {/* Desktop table */}
//         <div className="hidden sm:block rounded-2xl overflow-hidden border border-slate-200 shadow-sm mb-4">
//           <div className="grid grid-cols-4 bg-orange-600 text-white text-xs font-bold uppercase tracking-wider">
//             <div className="px-6 py-4">Procedure</div>
//             <div className="px-6 py-4 text-center">🇮🇳 India (PaxGrow)</div>
//             <div className="px-6 py-4 text-center">Africa (local)</div>
//             <div className="px-6 py-4 text-center">UK / USA</div>
//           </div>
//           {data.costRows.map((row, i) => (
//             <div
//               key={i}
//               className={`grid grid-cols-4 border-t border-slate-100 hover:bg-orange-50/40 transition-colors ${i % 2 === 0 ? "bg-white" : "bg-slate-50/60"}`}
//             >
//               <div className="px-6 py-5 text-slate-700 text-sm font-medium">
//                 {row.procedure}
//               </div>
//               <div className="px-6 py-5 text-center">
//                 <span className="text-orange-600 font-bold text-sm">
//                   {row.india}
//                 </span>
//               </div>
//               <div className="px-6 py-5 text-center text-slate-500 text-sm">
//                 {row.africa}
//               </div>
//               <div className="px-6 py-5 text-center text-slate-500 text-sm">
//                 {row.ukusa}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Mobile cards */}
//         <div className="sm:hidden space-y-4 mb-4">
//           {data.costRows.map((row, i) => (
//             <div
//               key={i}
//               className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm"
//             >
//               <p className="text-slate-800 font-semibold text-sm mb-4">
//                 {row.procedure}
//               </p>
//               <div className="space-y-2.5">
//                 {[
//                   {
//                     label: "🇮🇳 India (PaxGrow)",
//                     val: row.india,
//                     highlight: true,
//                   },
//                   { label: "Africa (local)", val: row.africa, highlight: false },
//                   { label: "UK / USA", val: row.ukusa, highlight: false },
//                 ].map((r) => (
//                   <div
//                     key={r.label}
//                     className="flex justify-between items-center"
//                   >
//                     <span className="text-slate-500 text-xs">{r.label}</span>
//                     <span
//                       className={`text-sm font-semibold ${r.highlight ? "text-orange-600" : "text-slate-600"}`}
//                     >
//                       {r.val}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>

//         <p className="text-slate-400 text-xs mb-5">
//           All costs are approximate and verified from hospital packages (Q1
//           2026). Final quote provided after medical report review.
//         </p>
//         <div className="flex flex-wrap items-center gap-3">
//           {["NABH", "JCI"].map((badge) => (
//             <span
//               key={badge}
//               className="bg-orange-50 border border-orange-200 text-orange-700 text-xs font-semibold px-4 py-1.5 rounded-full"
//             >
//               {badge}
//             </span>
//           ))}
//           <span className="text-slate-400 text-xs">
//             All PaxGrow partner hospitals hold NABH or JCI accreditation —
//             verifiable at nabh.co
//           </span>
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // WHY CHOOSE SCREEN
// // ============================================
// const WhyChooseScreen = ({ treatment }) => (
//   <section className="py-16 bg-slate-50">
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <div className="grid lg:grid-cols-2 gap-14 items-center">
//         <div>
//           <span className="text-orange-600 font-semibold text-sm uppercase tracking-widest">
//             Treatment Benefits
//           </span>
//           <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4">
//             Why Choose {treatment.shortName}?
//           </h2>
//           <p className="text-slate-500 mb-7 leading-relaxed text-sm">
//             Our advanced approach to {treatment.shortName.toLowerCase()} ensures
//             the best possible outcome for every patient.
//           </p>
//           <div className="space-y-3">
//             {treatment.benefits.map((benefit, i) => (
//               <div
//                 key={i}
//                 className="flex items-start gap-4 bg-white rounded-2xl p-4 border border-slate-100 shadow-sm hover:shadow-md hover:border-orange-100 transition-all group"
//               >
//                 <div className="w-8 h-8 bg-orange-100 rounded-xl flex items-center justify-center shrink-0 group-hover:bg-orange-600 transition-colors">
//                   <CheckCircle className="w-4 h-4 text-orange-600 group-hover:text-white transition-colors" />
//                 </div>
//                 <p className="text-slate-700 text-sm font-medium pt-1">
//                   {benefit}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="space-y-5">
//           <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl p-8 text-white">
//             <div className="flex items-center gap-3 mb-6">
//               <div className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center">
//                 <Award className="w-6 h-6 text-white" />
//               </div>
//               <div>
//                 <div className="font-bold text-lg">Top Rated Treatment</div>
//                 <div className="text-orange-200 text-xs">
//                   By India's Medical Association
//                 </div>
//               </div>
//             </div>
//             <div className="grid grid-cols-2 gap-4">
//               {[
//                 { label: "Experience", value: "15+ Years" },
//                 { label: "Patients", value: "10k+" },
//                 { label: "Experts", value: "50+" },
//                 { label: "Centers", value: "100+" },
//               ].map((item) => (
//                 <div
//                   key={item.label}
//                   className="bg-white/10 rounded-2xl p-4 text-center"
//                 >
//                   <div className="text-2xl font-bold">{item.value}</div>
//                   <div className="text-orange-200 text-xs mt-1">
//                     {item.label}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* CTA card */}
//           <div className="bg-white rounded-3xl border border-slate-200 shadow-xl p-8">
//             <h4 className="font-bold text-2xl text-slate-900 mb-3 leading-tight">
//               Not Sure If You Need{" "}
//               <span className="text-orange-600">Surgery</span>?
//             </h4>
//             <div className="space-y-2 mb-6">
//               {[
//                 "Get a free opinion from our expert specialists",
//                 "Zero cost, zero commitment — just expert advice",
//               ].map((txt, i) => (
//                 <div key={i} className="flex items-start gap-2">
//                   <CheckCircle className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" />
//                   <p className="text-slate-600 text-sm">{txt}</p>
//                 </div>
//               ))}
//             </div>
//             <ConsultationModal
//               trigger={
//                 <Button className="w-full bg-orange-600 hover:bg-orange-700 text-white rounded-xl py-5 font-bold text-sm mb-3">
//                   📞 Get Free Consultation{" "}
//                   <ArrowRight className="ml-2 h-4 w-4" />
//                 </Button>
//               }
//             />
//             <a
//               href={`https://wa.me/${WHATSAPP_NUMBER}`}
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <Button
//                 variant="outline"
//                 className="w-full border-2 border-green-500 text-green-600 hover:bg-green-50 rounded-xl py-5 font-bold text-sm"
//               >
//                 <MessageCircle className="w-4 h-4 mr-2 fill-green-500 text-green-500" />
//                 Chat on WhatsApp
//               </Button>
//             </a>
//             <div className="grid grid-cols-3 gap-3 mt-5 pt-4 border-t border-slate-100">
//               {[
//                 { v: "50K+", l: "Patients Treated" },
//                 { v: "98%", l: "Success Rate" },
//                 { v: "24/7", l: "Support Available" },
//               ].map((s, i) => (
//                 <div
//                   key={i}
//                   className={`text-center ${i === 1 ? "border-x border-slate-100" : ""}`}
//                 >
//                   <div className="text-orange-500 font-bold text-lg">{s.v}</div>
//                   <div className="text-xs text-slate-500">{s.l}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </section>
// );

// // ============================================
// // HOW IT WORKS SCREEN
// // ============================================
// const HowItWorksScreen = ({ treatment }) => (
//   <section className="py-16 bg-white">
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <div className="text-center mb-14">
//         <span className="text-orange-600 font-semibold text-sm uppercase tracking-widest">
//           Step by Step
//         </span>
//         <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4">
//           How It Works
//         </h2>
//         <p className="text-slate-500 max-w-xl mx-auto text-sm">
//           From your first consultation to complete recovery, we guide you every
//           step of the way.
//         </p>
//       </div>

//       <div className="relative">
//         <div className="hidden lg:block absolute top-20 left-0 right-0 h-0.5 bg-gradient-to-r from-orange-200 via-orange-400 to-orange-200 mx-32" />
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//           {treatment.procedure.map((step, i) => {
//             const Icon = step.icon;
//             return (
//               <div
//                 key={i}
//                 className="relative flex flex-col items-center text-center group"
//               >
//                 <div className="relative z-10 mb-5">
//                   <div className="w-16 h-16 bg-orange-600 rounded-2xl flex items-center justify-center shadow-lg shadow-orange-200 group-hover:scale-110 transition-transform">
//                     <Icon className="w-7 h-7 text-white" />
//                   </div>
//                   <div className="absolute -top-2 -right-2 w-6 h-6 bg-slate-900 text-white rounded-full text-xs font-bold flex items-center justify-center">
//                     {i + 1}
//                   </div>
//                 </div>
//                 <div className="bg-slate-50 rounded-2xl p-5 w-full border border-slate-100 group-hover:border-orange-200 group-hover:shadow-md transition-all">
//                   <h3 className="font-bold text-slate-900 mb-2 text-sm">
//                     {step.title}
//                   </h3>
//                   <div className="inline-flex items-center gap-1.5 bg-orange-100 text-orange-700 rounded-full px-3 py-1 text-xs font-semibold">
//                     <Clock className="w-3 h-3" />
//                     {step.duration}
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       <div className="mt-12 bg-slate-50 rounded-3xl p-7 border border-slate-100 flex flex-col md:flex-row items-center justify-between gap-5">
//         <div className="flex items-center gap-4">
//           <div className="w-12 h-12 bg-orange-100 rounded-2xl flex items-center justify-center">
//             <MessageCircle className="w-6 h-6 text-orange-600" />
//           </div>
//           <div>
//             <div className="font-bold text-slate-900 text-sm">
//               Have questions about the procedure?
//             </div>
//             <div className="text-slate-500 text-xs">
//               Our care coordinators are available 24/7
//             </div>
//           </div>
//         </div>
//         <div className="flex flex-col sm:flex-row gap-3 shrink-0">
//           <ConsultationModal
//             trigger={
//               <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-7 py-5 font-semibold text-sm">
//                 Book Now <ArrowRight className="ml-2 h-4 w-4" />
//               </Button>
//             }
//           />
//           <a
//             href={`https://wa.me/${WHATSAPP_NUMBER}`}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <Button
//               variant="outline"
//               className="border-2 border-green-500 text-green-600 hover:bg-green-50 rounded-full px-7 py-5 font-semibold text-sm w-full sm:w-auto"
//             >
//               <MessageCircle className="w-4 h-4 mr-2 fill-green-500 text-green-500" />
//               WhatsApp Us
//             </Button>
//           </a>
//         </div>
//       </div>
//     </div>
//   </section>
// );

// // ============================================
// // TESTIMONIALS SCREEN
// // ============================================
// const TestimonialsScreen = ({ treatment }) => (
//   <section className="py-16 bg-slate-900 text-white overflow-hidden">
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <div className="text-center mb-14">
//         <span className="text-orange-400 font-semibold text-sm uppercase tracking-widest">
//           Real Stories
//         </span>
//         <h2 className="text-3xl sm:text-4xl font-bold text-white mt-3 mb-4">
//           Patient Success Stories
//         </h2>
//         <p className="text-slate-400 max-w-xl mx-auto text-sm">
//           Hear from real patients who transformed their lives with our care.
//         </p>
//       </div>

//       <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12">
//         <div className="text-center">
//           <div className="text-6xl font-bold text-white">4.9</div>
//           <div className="flex justify-center mt-2">
//             {[...Array(5)].map((_, i) => (
//               <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
//             ))}
//           </div>
//           <div className="text-slate-400 text-sm mt-1">Overall Rating</div>
//         </div>
//         <div className="w-px h-16 bg-slate-700 hidden sm:block" />
//         <div className="flex gap-8">
//           {[
//             { label: "Total Reviews", val: "3,000+" },
//             { label: "Recommend Us", val: "99%" },
//             { label: "5-Star Reviews", val: "92%" },
//           ].map((s) => (
//             <div key={s.label} className="text-center">
//               <div className="text-2xl font-bold text-orange-400">{s.val}</div>
//               <div className="text-slate-400 text-xs mt-1">{s.label}</div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="grid md:grid-cols-3 gap-5">
//         {treatment.testimonials.map((t, i) => (
//           <div
//             key={i}
//             className="bg-slate-800 rounded-3xl p-6 border border-slate-700 hover:border-orange-500/50 transition-colors"
//           >
//             <div className="text-4xl text-orange-500 font-serif leading-none mb-4">
//               "
//             </div>
//             <div className="flex mb-4">
//               {[...Array(t.rating)].map((_, j) => (
//                 <Star key={j} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
//               ))}
//             </div>
//             <p className="text-slate-300 text-sm leading-relaxed mb-5 italic">
//               {t.text}
//             </p>
//             <div className="inline-block bg-orange-500/20 text-orange-400 rounded-full px-3 py-1 text-xs font-medium mb-5">
//               {t.treatment}
//             </div>
//             <div className="flex items-center gap-3 pt-4 border-t border-slate-700">
//               <img
//                 src={t.image}
//                 alt={t.name}
//                 className="w-11 h-11 rounded-full object-cover ring-2 ring-orange-500/30"
//               />
//               <div>
//                 <div className="font-semibold text-white text-sm">{t.name}</div>
//                 <div className="text-slate-400 text-xs">
//                   Age {t.age} · {t.location} · {t.date}
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       <div className="mt-12 text-center">
//         <p className="text-slate-400 text-sm mb-5">
//           Ready to write your own success story?
//         </p>
//         <div className="flex flex-col sm:flex-row gap-4 justify-center">
//           <ConsultationModal
//             trigger={
//               <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold">
//                 Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//               </Button>
//             }
//           />
//           <a
//             href={`https://wa.me/${WHATSAPP_NUMBER}`}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <Button
//               variant="outline"
//               className="border-2 border-green-500 text-green-600 hover:bg-green-50 rounded-full px-8 py-6 font-semibold"
//             >
//               <MessageCircle className="w-4 h-4 mr-2 fill-green-500 text-green-500" />
//               Chat on WhatsApp
//             </Button>
//           </a>
//         </div>
//       </div>
//     </div>
//   </section>
// );

// // ============================================
// // FAQ SCREEN — Phone CTA removed, WhatsApp only
// // ============================================
// const FAQScreen = ({ treatment }) => {
//   const [openIdx, setOpenIdx] = useState(0);

//   return (
//     <section className="py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid lg:grid-cols-2 gap-14 items-start">
//           {/* LEFT — sticky info + CTA */}
//           <div className="lg:sticky lg:top-24">
//             <span className="text-orange-600 font-semibold text-sm uppercase tracking-widest">
//               FAQ
//             </span>
//             <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4">
//               Frequently Asked Questions
//             </h2>
//             <p className="text-slate-500 leading-relaxed mb-7 text-sm">
//               Everything you need to know about {treatment.name}. Can't find the
//               answer? We're here to help.
//             </p>

//             {/* Contact card — WhatsApp only */}
//             <div className="bg-gradient-to-br from-slate-50 to-orange-50 border border-orange-100 rounded-3xl p-6 space-y-4">
//               {/* Header */}
//               <div className="flex items-center gap-3">
//                 <div className="w-11 h-11 bg-green-100 rounded-xl flex items-center justify-center shrink-0">
//                   <MessageCircle className="w-5 h-5 text-green-600" />
//                 </div>
//                 <div>
//                   <div className="font-semibold text-slate-900 text-sm">
//                     Still have questions?
//                   </div>
//                   <div className="text-slate-500 text-xs">
//                     We're here to help
//                   </div>
//                 </div>
//               </div>

//               {/* WhatsApp CTA */}
//               <a
//                 href={`https://wa.me/${WHATSAPP_NUMBER}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="flex items-center justify-center gap-2 w-full bg-green-500 hover:bg-green-600 text-white rounded-xl py-3.5 font-semibold text-sm transition-colors shadow-md shadow-green-500/20"
//               >
//                 <MessageCircle className="w-4 h-4 fill-white" />
//                 Chat on WhatsApp
//               </a>

//               {/* Trust row */}
//               <div className="flex items-center justify-between pt-2 border-t border-orange-100">
//                 {[
//                   { icon: Timer, label: "48hr reply" },
//                   { icon: DollarSign, label: "Free advice" },
//                   { icon: Lock, label: "Confidential" },
//                 ].map((item, i) => {
//                   const Icon = item.icon;
//                   return (
//                     <div key={i} className="flex flex-col items-center gap-1">
//                       <div className="w-8 h-8 bg-white rounded-lg border border-slate-200 flex items-center justify-center shadow-sm">
//                         <Icon className="w-3.5 h-3.5 text-orange-500" />
//                       </div>
//                       <span className="text-slate-500 text-[10px] font-medium">
//                         {item.label}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* RIGHT — accordion */}
//           <div className="space-y-3">
//             {treatment.faqs.map((faq, i) => (
//               <div
//                 key={i}
//                 className={`border rounded-2xl overflow-hidden transition-all ${openIdx === i
//                   ? "border-orange-200 shadow-md"
//                   : "border-slate-200"
//                   }`}
//               >
//                 <button
//                   onClick={() => setOpenIdx(openIdx === i ? null : i)}
//                   className={`w-full flex items-center justify-between p-5 text-left transition-colors ${openIdx === i
//                     ? "bg-orange-50"
//                     : "bg-white hover:bg-slate-50"
//                     }`}
//                 >
//                   <span className="font-semibold text-slate-900 text-sm pr-4 leading-relaxed">
//                     {faq.q}
//                   </span>
//                   <div
//                     className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-colors ${openIdx === i ? "bg-orange-600" : "bg-slate-100"
//                       }`}
//                   >
//                     {openIdx === i ? (
//                       <ChevronUp className="w-4 h-4 text-white" />
//                     ) : (
//                       <ChevronDown className="w-4 h-4 text-slate-600" />
//                     )}
//                   </div>
//                 </button>
//                 {openIdx === i && (
//                   <div className="px-5 pb-5 bg-orange-50 border-t border-orange-100">
//                     <p className="text-slate-600 text-sm leading-relaxed pt-4">
//                       {faq.a}
//                     </p>
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// // ============================================
// // FREE MEDICAL REVIEW CTA SCREEN
// // ============================================
// const FreeMedicalReviewScreen = ({ treatment }) => (
//   <section className="py-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
//     <div className="absolute inset-0 overflow-hidden pointer-events-none">
//       <div className="absolute -top-40 -right-40 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl" />
//       <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-green-500/10 rounded-full blur-3xl" />
//     </div>

//     <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//       <div className="inline-flex items-center gap-2 bg-green-500/20 border border-green-500/30 text-green-400 rounded-full px-4 py-1.5 text-xs font-semibold mb-6">
//         <Sparkles className="w-3.5 h-3.5" />
//         Free · No Commitment · 48hr Response
//       </div>

//       <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
//         Ready to get a free
//         <br />
//         <span className="text-orange-400">medical review?</span>
//       </h2>

//       <p className="text-slate-300 text-base sm:text-lg leading-relaxed mb-8 max-w-2xl mx-auto">
//         Send your reports on WhatsApp. Within 48 hours, Samar personally reviews
//         your case and sends you a plain-English summary with treatment options
//         and cost estimates.{" "}
//         <span className="text-white font-semibold">
//           Zero charge. Zero commitment.
//         </span>
//       </p>

//       <a
//         href={`https://wa.me/${WHATSAPP_NUMBER}`}
//         target="_blank"
//         rel="noopener noreferrer"
//         className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-2xl px-8 py-5 font-bold text-base sm:text-lg transition-all shadow-xl shadow-green-500/25 hover:shadow-green-500/40 hover:-translate-y-0.5 mb-5"
//       >
//         <MessageCircle className="w-6 h-6 fill-white" />
//         Send Reports on WhatsApp
//       </a>

//       <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-slate-400 mb-10">
//         {[
//           "Free review",
//           "No commitment",
//           "Reply within 48 hours",
//           "Zero coordination fees",
//         ].map((item, i) => (
//           <span key={i} className="flex items-center gap-1.5">
//             <CheckCircle className="w-3.5 h-3.5 text-green-500" />
//             {item}
//           </span>
//         ))}
//       </div>

//       <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
//         {[
//           {
//             icon: FileText,
//             bg: "bg-orange-500/20",
//             border: "border-orange-500/30",
//             color: "text-orange-400",
//             label: "Upload any format",
//             sub: "PDF, image, scan",
//           },
//           {
//             icon: Timer,
//             bg: "bg-blue-500/20",
//             border: "border-blue-500/30",
//             color: "text-blue-400",
//             label: "48-hour response",
//             sub: "Personal review",
//           },
//           {
//             icon: BadgeCheck,
//             bg: "bg-violet-500/20",
//             border: "border-violet-500/30",
//             color: "text-violet-400",
//             label: "JCI & NABH",
//             sub: "Accredited hospitals",
//           },
//           {
//             icon: Globe,
//             bg: "bg-green-500/20",
//             border: "border-green-500/30",
//             color: "text-green-400",
//             label: "Visa guidance",
//             sub: "Included free",
//           },
//         ].map((card, i) => {
//           const Icon = card.icon;
//           return (
//             <div
//               key={i}
//               className={`${card.bg} border ${card.border} rounded-2xl p-4 text-center`}
//             >
//               <div
//                 className={`w-10 h-10 rounded-xl ${card.bg} flex items-center justify-center mx-auto mb-3`}
//               >
//                 <Icon className={`w-5 h-5 ${card.color}`} />
//               </div>
//               <div className="text-white font-semibold text-sm mb-0.5">
//                 {card.label}
//               </div>
//               <div className="text-slate-400 text-xs">{card.sub}</div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   </section>
// );

// // ============================================
// // FLOATING CTA (Mobile)
// // ============================================
// const FloatingCTA = () => {
//   const [visible, setVisible] = useState(false);
//   React.useEffect(() => {
//     const handleScroll = () => setVisible(window.scrollY > 400);
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);
//   if (!visible) return null;

//   return (
//     <div className="fixed bottom-0 left-0 right-0 z-30 md:hidden bg-white border-t border-slate-200 px-4 py-3 shadow-xl">
//       <div className="flex gap-3">
//         <ConsultationModal
//           trigger={
//             <Button className="flex-1 bg-orange-600 hover:bg-orange-700 text-white rounded-xl py-5 font-semibold text-sm">
//               Free Consultation
//             </Button>
//           }
//         />
//         <a
//           href={`https://wa.me/${WHATSAPP_NUMBER}`}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="flex-1"
//         >
//           <Button
//             variant="outline"
//             className="w-full border-2 border-green-500 text-green-600 rounded-xl py-5 font-semibold text-sm"
//           >
//             <MessageCircle className="w-4 h-4 mr-1.5 fill-green-500 text-green-500" />
//             WhatsApp
//           </Button>
//         </a>
//       </div>
//     </div>
//   );
// };

// // ============================================
// // MAIN PAGE
// // ============================================
// const TreatmentLandingPage = () => {
//   const { treatmentSlug } = useParams();
//   const slug = treatmentSlug || "cardiac-surgery";
//   const treatment = TREATMENTS_DATA[slug];

//   if (!treatment) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-slate-50">
//         <div className="text-center">
//           <div className="text-6xl mb-4">🔍</div>
//           <h2 className="text-2xl font-bold text-slate-900 mb-2">
//             Treatment Not Found
//           </h2>
//           <p className="text-slate-500 mb-6">
//             The treatment page you're looking for doesn't exist.
//           </p>
//           <a
//             href="/treatments"
//             className="bg-orange-600 text-white rounded-full px-8 py-3 font-semibold hover:bg-orange-700 transition-colors"
//           >
//             View All Treatments
//           </a>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-white">
//       <HeroScreen treatment={treatment} />
//       <StatsScreen treatment={treatment} />
//       <WhyIndiaScreen treatment={treatment} />
//       <ProcessScreen treatment={treatment} />
//       <ConditionsScreen treatment={treatment} />
//       <CostComparisonScreen treatment={treatment} />
//       <WhyChooseScreen treatment={treatment} />
//       <HowItWorksScreen treatment={treatment} />
//       <TestimonialsScreen treatment={treatment} />
//       <FAQScreen treatment={treatment} />
//       <FreeMedicalReviewScreen treatment={treatment} />
//       <FloatingCTA />
//     </div>
//   );
// };

// export default TreatmentLandingPage;


// src/pages/treatments/TreatmentLandingPage.jsx
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ConsultationModal from "@/components/ConsultationModal";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import {
  CheckCircle, Clock, Star, Users, Shield, ArrowRight,
  ChevronDown, ChevronUp, Award, MessageCircle, FileText,
  Plane, Microscope, Stethoscope, BadgeCheck, Globe, Timer,
  DollarSign, TrendingDown, Sparkles, Send, Zap, Lock,
  Activity, ThumbsUp, Heart, HeartPulse, Building2, Video,
} from "lucide-react";
import { Loader2 } from "lucide-react";
import axios from "axios";
import {
  TREATMENTS_DATA, PAXGROW_DATA, PROCESS_STEPS,
  WHATSAPP_NUMBER, API_BASE, TREATMENT_OPTIONS, COUNTRIES,
} from "@/data/treatmentLandingData";

// ============================================
// HERO SCREEN
// ============================================
const HeroScreen = ({ treatment }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "", email: "", phone: "", country: "",
    treatment: treatment.name || "", message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_BASE}/consultations`, form);
      const whatsappMessage = encodeURIComponent(
        `Hi, I just submitted a consultation request.\n\nName: ${form.name}\nPhone: ${form.phone}\nTreatment: ${form.treatment}\nCountry: ${form.country}`
      );
      const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${whatsappMessage}`;
      navigate("/thank-you", { state: { formData: form, whatsappUrl } });
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <section className="relative min-h-screen flex items-center bg-slate-900 overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${treatment.heroImage})` }} />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-900/97 via-slate-900/85 to-slate-900/50" />
      <div className="absolute top-20 right-10 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 left-10 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 w-full">
        <div className="grid lg:grid-cols-2 gap-10 items-start">
          {/* LEFT */}
          <div className="lg:sticky lg:top-20">
            <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/30 text-orange-300 rounded-full px-4 py-1.5 text-xs font-semibold mb-5">
              <Award className="w-3.5 h-3.5" />
              {treatment.category} · {treatment.badge}
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-3">
              {treatment.name}
            </h1>
            <p className="text-xl text-orange-400 font-semibold mb-3">{treatment.tagline}</p>
            <div className="inline-flex items-center gap-2 bg-green-500/15 border border-green-500/30 text-white rounded-xl px-4 py-2.5 text-sm font-medium mb-5">
              <TrendingDown className="w-4 h-4 text-white shrink-0" />
              {treatment.heroSubtag}
            </div>
            <p className="text-slate-300 text-sm leading-relaxed mb-6 max-w-lg">
              {treatment.description}
            </p>
            <div className="flex flex-wrap gap-6 mb-6">
              {treatment.stats.slice(0, 2).map((stat, i) => (
                <div key={i} className="text-white">
                  <div className="text-2xl font-bold text-orange-400">{stat.value}</div>
                  <div className="text-xs text-slate-400">{stat.label}</div>
                </div>
              ))}
            </div>
            <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-full px-7 py-4 font-semibold text-sm transition-all shadow-lg shadow-green-500/30 hover:shadow-green-500/50 hover:-translate-y-0.5 mb-6">
              <MessageCircle className="w-5 h-5 fill-white" />
              Send Reports — Free 48hr Review
            </a>
            <div className="grid grid-cols-2 gap-2 mb-6 max-w-xs">
              {[
                { icon: DollarSign, label: "Zero coordination fees", color: "text-green-400" },
                { icon: Timer, label: "Reply within 48 hours", color: "text-blue-400" },
                { icon: BadgeCheck, label: "JCI & NABH hospitals", color: "text-violet-400" },
                { icon: Plane, label: "Visa guidance included", color: "text-orange-400" },
              ].map((b, i) => (
                <div key={i} className="flex items-center gap-2">
                  <b.icon className={`w-3.5 h-3.5 shrink-0 ${b.color}`} />
                  <span className="text-slate-300 text-xs">{b.label}</span>
                </div>
              ))}
            </div>
            {treatment.costCard && (
              <div className="bg-white/10 backdrop-blur border border-white/20 rounded-2xl p-4 max-w-xs">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-7 h-7 bg-orange-500/20 rounded-lg flex items-center justify-center">
                    <TrendingDown className="w-3.5 h-3.5 text-orange-400" />
                  </div>
                  <span className="text-white/60 text-xs font-medium">{treatment.costCard.label}</span>
                </div>
                <div className="text-2xl font-bold text-orange-400 leading-none mb-1">
                  {treatment.costCard.value}
                </div>
                <div className="text-white/40 text-xs">{treatment.costCard.compare}</div>
              </div>
            )}
          </div>

          {/* RIGHT — FORM */}
          <div className="lg:sticky lg:top-20">
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
              <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-5 text-white">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
                    <FileText className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-xl">Free Consultation</h3>
                    <p className="text-orange-100 text-xs">Expert advice · No commitment · 48hr reply</p>
                  </div>
                </div>
                <div className="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2 mt-2">
                  <div className="flex -space-x-2">
                    {["men/11", "women/31", "men/21"].map((p, i) => (
                      <img key={i} src={`https://randomuser.me/api/portraits/${p}.jpg`} alt=""
                        className="w-6 h-6 rounded-full border-2 border-orange-500 object-cover" />
                    ))}
                  </div>
                  <span className="text-orange-100 text-xs">
                    <strong className="text-white">127 patients</strong> consulted this week
                  </span>
                </div>
              </div>
              <div className="p-6">
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <Label className="text-slate-700 text-sm font-semibold">Full Name *</Label>
                    <Input required value={form.name}
                      onChange={(e) => setForm({ ...form, name: e.target.value })}
                      placeholder="Your full name"
                      className="mt-1 rounded-xl border-slate-200 focus:border-orange-400 focus:ring-orange-400" />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <Label className="text-slate-700 text-sm font-semibold">Email *</Label>
                      <Input type="email" required value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        placeholder="your@email.com"
                        className="mt-1 rounded-xl border-slate-200 focus:border-orange-400" />
                    </div>
                    <div>
                      <Label className="text-slate-700 text-sm font-semibold">Phone *</Label>
                      <Input required value={form.phone}
                        onChange={(e) => setForm({ ...form, phone: e.target.value })}
                        placeholder="+1 234 567 890"
                        className="mt-1 rounded-xl border-slate-200 focus:border-orange-400" />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <Label className="text-slate-700 text-sm font-semibold">Country *</Label>
                      <Select onValueChange={(v) => setForm({ ...form, country: v })}>
                        <SelectTrigger className="mt-1 rounded-xl border-slate-200">
                          <SelectValue placeholder="Select country" />
                        </SelectTrigger>
                        <SelectContent>
                          {COUNTRIES.map((c) => (
                            <SelectItem key={c} value={c}>{c}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                    <div>
                      <Label className="text-slate-700 text-sm font-semibold">Treatment *</Label>
                      <Select value={form.treatment}
                        onValueChange={(v) => setForm({ ...form, treatment: v })}>
                        <SelectTrigger className="mt-1 rounded-xl border-slate-200">
                          <SelectValue placeholder="Select treatment" />
                        </SelectTrigger>
                        <SelectContent>
                          {TREATMENT_OPTIONS.map((t) => (
                            <SelectItem key={t} value={t}>{t}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                  <div>
                    <Label className="text-slate-700 text-sm font-semibold">
                      Medical Details{" "}
                      <span className="text-slate-400 font-normal">(Optional)</span>
                    </Label>
                    <Textarea value={form.message}
                      onChange={(e) => setForm({ ...form, message: e.target.value })}
                      placeholder="Briefly describe your condition or attach reports later on WhatsApp..."
                      rows={3}
                      className="mt-1 rounded-xl border-slate-200 focus:border-orange-400" />
                  </div>
                  <Button type="submit" disabled={loading}
                    className="w-full bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-bold h-12 shadow-md shadow-orange-200 text-sm">
                    {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Send className="h-4 w-4 mr-2" />}
                    {loading ? "Submitting..." : "Get My Free Consultation"}
                  </Button>
                  <div className="flex items-center justify-center gap-4 pt-1">
                    {[
                      { icon: Lock, label: "100% Confidential" },
                      { icon: Zap, label: "Reply in 48hrs" },
                      { icon: DollarSign, label: "Zero Fees" },
                    ].map((item, i) => (
                      <React.Fragment key={i}>
                        {i > 0 && <span className="text-slate-200">·</span>}
                        <span className="flex items-center gap-1.5 text-xs text-slate-400">
                          <item.icon className="w-3 h-3 text-slate-400" />
                          {item.label}
                        </span>
                      </React.Fragment>
                    ))}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40">
        <span className="text-xs">Scroll to explore</span>
        <div className="w-5 h-8 border border-white/20 rounded-full flex items-start justify-center p-1">
          <div className="w-1 h-2 bg-white/40 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
};

// ============================================
// STATS SCREEN
// ============================================
const StatsScreen = ({ treatment }) => {
  const statStyles = [
    { bg: "bg-orange-50", border: "border-orange-200", iconBg: "bg-orange-100", val: "text-orange-700", icon: "text-orange-600" },
    { bg: "bg-blue-50", border: "border-blue-200", iconBg: "bg-blue-100", val: "text-blue-700", icon: "text-blue-600" },
    { bg: "bg-violet-50", border: "border-violet-200", iconBg: "bg-violet-100", val: "text-violet-700", icon: "text-violet-600" },
    { bg: "bg-green-50", border: "border-green-200", iconBg: "bg-green-100", val: "text-green-700", icon: "text-green-600" },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="text-orange-600 font-medium text-xs uppercase tracking-widest">Our track record</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 mb-2 leading-tight">
            Numbers that speak for themselves
          </h2>
          <p className="text-slate-500 text-sm max-w-md mx-auto leading-relaxed">
            Two decades of clinical excellence trusted by patients across every corner of India.
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {treatment.stats.map((stat, i) => {
            const Icon = stat.icon;
            const s = statStyles[i];
            return (
              <div key={i}
                className={`relative overflow-hidden rounded-2xl border ${s.bg} ${s.border} p-6 text-center hover:-translate-y-1 hover:shadow-lg transition-all duration-200`}>
                <div className={`absolute -top-5 -right-5 w-20 h-20 rounded-full ${s.iconBg} opacity-40`} />
                <div className={`relative z-10 w-12 h-12 ${s.iconBg} rounded-xl flex items-center justify-center mx-auto mb-4`}>
                  <Icon className={`w-5 h-5 ${s.icon}`} />
                </div>
                <div className={`relative z-10 text-3xl sm:text-4xl font-bold ${s.val} mb-1.5 leading-none`}>
                  {stat.value}
                </div>
                <div className="relative z-10 text-slate-500 text-xs font-medium">{stat.label}</div>
              </div>
            );
          })}
        </div>
        <div className="bg-slate-900 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div className="flex-1">
            <h3 className="text-xl font-bold text-white mb-2">India's most trusted medical centre</h3>
            <p className="text-slate-400 text-sm">Setting the standard in patient outcomes since 2016.</p>
          </div>
          <div className="hidden md:block w-px self-stretch bg-white/10" />
          <div className="flex gap-8 shrink-0">
            {[{ val: "50+", lbl: "Hospitals" }, { val: "25+", lbl: "Cities" }, { val: "30+", lbl: "Awards" }].map((s) => (
              <div key={s.lbl} className="text-center">
                <div className="text-3xl font-bold text-orange-400">{s.val}</div>
                <div className="text-slate-500 text-xs mt-1">{s.lbl}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// ============================================
// WHY INDIA SCREEN
// ============================================
const WhyIndiaScreen = ({ treatment }) => {
  const data = PAXGROW_DATA[treatment.slug];
  if (!data) return null;

  return (
    <section className="py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">
            {data.whyIndiaSubtitle}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4 leading-tight">
            {data.whyIndiaTitle}
          </h2>
          <p className="text-slate-500 text-sm max-w-lg mx-auto">
            Top-tier hospitals. No waiting lists. Expert surgeons. At a fraction of Western costs.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            { icon: Microscope, color: "bg-orange-100 text-orange-600", border: "border-orange-200" },
            { icon: Stethoscope, color: "bg-blue-100 text-blue-600", border: "border-blue-200" },
            { icon: Timer, color: "bg-violet-100 text-violet-600", border: "border-violet-200" },
            { icon: Globe, color: "bg-green-100 text-green-600", border: "border-green-200" },
          ].map((style, i) => {
            const Icon = style.icon;
            return (
              <div key={i} className={`bg-white rounded-2xl border ${style.border} p-6 hover:shadow-md transition-all`}>
                <div className={`w-11 h-11 rounded-xl ${style.color} flex items-center justify-center mb-4`}>
                  <Icon className="w-5 h-5" />
                </div>
                <p className="text-slate-700 text-sm font-medium leading-relaxed">
                  {data.whyIndiaReasons[i]}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

// ============================================
// PROCESS SCREEN
// ============================================
const ProcessScreen = ({ treatment }) => {
  const data = PAXGROW_DATA[treatment.slug];
  if (!data) return null;

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">THE PROCESS</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4 leading-tight">
            From First WhatsApp<br />to Safe Return Home
          </h2>
          <p className="text-slate-500 text-sm max-w-md mx-auto">
            PaxGrow manages every step so you can focus entirely on getting better.
          </p>
        </div>
        <div className="relative max-w-3xl mx-auto">
          <div className="absolute left-6 top-6 bottom-6 w-0.5 bg-gradient-to-b from-orange-300 via-violet-300 to-rose-300 hidden sm:block" />
          <div className="space-y-6">
            {PROCESS_STEPS.map((step) => {
              const Icon = step.icon;
              return (
                <div key={step.num} className="relative flex gap-5 sm:gap-8">
                  <div className="relative z-10 shrink-0">
                    <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${step.color} flex items-center justify-center shadow-lg`}>
                      <Icon className="w-5 h-5 text-white" />
                    </div>
                    <div className="absolute -top-1 -right-1 w-5 h-5 bg-slate-900 text-white rounded-full text-[10px] font-bold flex items-center justify-center">
                      {step.num}
                    </div>
                  </div>
                  <div className="flex-1 bg-slate-50 border border-slate-100 rounded-2xl p-5 hover:border-orange-200 hover:shadow-sm transition-all">
                    <h3 className="font-semibold text-slate-900 text-sm mb-2">{step.title}</h3>
                    <p className="text-slate-500 text-xs leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="mt-10 text-center">
          <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-full px-8 py-4 font-semibold text-sm transition-all shadow-lg shadow-green-500/20">
            <MessageCircle className="w-5 h-5 fill-white" />
            Start with Step 1 — Send Your Reports
          </a>
          <p className="text-slate-400 text-xs mt-3">Free review · No commitment · Reply within 48 hours</p>
        </div>
      </div>
    </section>
  );
};

// ============================================
// CONDITIONS SCREEN
// ============================================
const ConditionsScreen = ({ treatment }) => {
  const data = PAXGROW_DATA[treatment.slug];
  if (!data) return null;
  const half = Math.ceil(data.conditions.length / 2);
  const col1 = data.conditions.slice(0, half);
  const col2 = data.conditions.slice(half);

  return (
    <section className="py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">WHAT WE TREAT</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 leading-tight">
            {data.conditionsTitle}
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-0 border border-slate-200 rounded-2xl overflow-hidden mb-5 bg-white">
          {[col1, col2].map((col, ci) =>
            col.map((cond, ri) => (
              <div key={`${ci}-${ri}`}
                className={`flex items-center gap-3 px-6 py-4 hover:bg-orange-50 transition-colors
                  ${ri < col.length - 1 ? "border-b border-slate-100" : ""}
                  ${ci === 0 ? "md:border-r border-slate-100" : ""}`}>
                <div className="w-7 h-7 bg-orange-100 rounded-lg flex items-center justify-center shrink-0">
                  <ArrowRight className="w-3.5 h-3.5 text-orange-500" />
                </div>
                <span className="text-slate-700 text-sm font-medium">{cond}</span>
              </div>
            ))
          )}
        </div>
        <div className="flex items-center gap-4 bg-gradient-to-r from-orange-50 to-amber-50 border border-orange-200 rounded-2xl px-6 py-5">
          <div className="w-11 h-11 rounded-xl bg-orange-500 flex items-center justify-center shrink-0">
            <Plane className="w-5 h-5 text-white" />
          </div>
          <div>
            <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">Typical India Stay</span>
            <p className="text-slate-700 font-semibold text-sm mt-0.5">{data.stayValue}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

// ============================================
// COST COMPARISON SCREEN
// ============================================
const CostComparisonScreen = ({ treatment }) => {
  const data = PAXGROW_DATA[treatment.slug];
  if (!data) return null;

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <span className="text-orange-600 font-semibold text-xs uppercase tracking-widest">COST COMPARISON</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-2 leading-tight">{data.costTitle}</h2>
        </div>
        <div className="hidden sm:block rounded-2xl overflow-hidden border border-slate-200 shadow-sm mb-4">
          <div className="grid grid-cols-4 bg-orange-600 text-white text-xs font-bold uppercase tracking-wider">
            <div className="px-6 py-4">Procedure</div>
            <div className="px-6 py-4 text-center">🇮🇳 India (PaxGrow)</div>
            <div className="px-6 py-4 text-center">Africa (local)</div>
            <div className="px-6 py-4 text-center">UK / USA</div>
          </div>
          {data.costRows.map((row, i) => (
            <div key={i}
              className={`grid grid-cols-4 border-t border-slate-100 hover:bg-orange-50/40 transition-colors ${i % 2 === 0 ? "bg-white" : "bg-slate-50/60"}`}>
              <div className="px-6 py-5 text-slate-700 text-sm font-medium">{row.procedure}</div>
              <div className="px-6 py-5 text-center">
                <span className="text-orange-600 font-bold text-sm">{row.india}</span>
              </div>
              <div className="px-6 py-5 text-center text-slate-500 text-sm">{row.africa}</div>
              <div className="px-6 py-5 text-center text-slate-500 text-sm">{row.ukusa}</div>
            </div>
          ))}
        </div>
        <div className="sm:hidden space-y-4 mb-4">
          {data.costRows.map((row, i) => (
            <div key={i} className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
              <p className="text-slate-800 font-semibold text-sm mb-4">{row.procedure}</p>
              <div className="space-y-2.5">
                {[
                  { label: "🇮🇳 India (PaxGrow)", val: row.india, highlight: true },
                  { label: "Africa (local)", val: row.africa, highlight: false },
                  { label: "UK / USA", val: row.ukusa, highlight: false },
                ].map((r) => (
                  <div key={r.label} className="flex justify-between items-center">
                    <span className="text-slate-500 text-xs">{r.label}</span>
                    <span className={`text-sm font-semibold ${r.highlight ? "text-orange-600" : "text-slate-600"}`}>
                      {r.val}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <p className="text-slate-400 text-xs mb-5">
          All costs are approximate and verified from hospital packages (Q1 2026). Final quote provided after medical report review.
        </p>
        <div className="flex flex-wrap items-center gap-3">
          {["NABH", "JCI"].map((badge) => (
            <span key={badge}
              className="bg-orange-50 border border-orange-200 text-orange-700 text-xs font-semibold px-4 py-1.5 rounded-full">
              {badge}
            </span>
          ))}
          <span className="text-slate-400 text-xs">
            All PaxGrow partner hospitals hold NABH or JCI accreditation — verifiable at nabh.co
          </span>
        </div>
      </div>
    </section>
  );
};

// ============================================
// WHY CHOOSE SCREEN
// ============================================
const WhyChooseScreen = ({ treatment }) => (
  <section className="py-16 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-widest">Treatment Benefits</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4">
            Why Choose {treatment.shortName}?
          </h2>
          <p className="text-slate-500 mb-7 leading-relaxed text-sm">
            Our advanced approach to {treatment.shortName.toLowerCase()} ensures the best possible outcome for every patient.
          </p>
          <div className="space-y-3">
            {treatment.benefits.map((benefit, i) => (
              <div key={i}
                className="flex items-start gap-4 bg-white rounded-2xl p-4 border border-slate-100 shadow-sm hover:shadow-md hover:border-orange-100 transition-all group">
                <div className="w-8 h-8 bg-orange-100 rounded-xl flex items-center justify-center shrink-0 group-hover:bg-orange-600 transition-colors">
                  <CheckCircle className="w-4 h-4 text-orange-600 group-hover:text-white transition-colors" />
                </div>
                <p className="text-slate-700 text-sm font-medium pt-1">{benefit}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="space-y-5">
          <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl p-8 text-white">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center">
                <Award className="w-6 h-6 text-white" />
              </div>
              <div>
                <div className="font-bold text-lg">Top Rated Treatment</div>
                <div className="text-orange-200 text-xs">By India's Medical Association</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { label: "Experience", value: "15+ Years" },
                { label: "Patients", value: "10k+" },
                { label: "Experts", value: "50+" },
                { label: "Centers", value: "100+" },
              ].map((item) => (
                <div key={item.label} className="bg-white/10 rounded-2xl p-4 text-center">
                  <div className="text-2xl font-bold">{item.value}</div>
                  <div className="text-orange-200 text-xs mt-1">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white rounded-3xl border border-slate-200 shadow-xl p-8">
            <h4 className="font-bold text-2xl text-slate-900 mb-3 leading-tight">
              Not Sure If You Need <span className="text-orange-600">Surgery</span>?
            </h4>
            <div className="space-y-2 mb-6">
              {["Get a free opinion from our expert specialists", "Zero cost, zero commitment — just expert advice"].map((txt, i) => (
                <div key={i} className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" />
                  <p className="text-slate-600 text-sm">{txt}</p>
                </div>
              ))}
            </div>
            <ConsultationModal
              trigger={
                <Button className="w-full bg-orange-600 hover:bg-orange-700 text-white rounded-xl py-5 font-bold text-sm mb-3">
                  📞 Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              }
            />
            <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer">
              <Button variant="outline"
                className="w-full border-2 border-green-500 text-green-600 hover:bg-green-50 rounded-xl py-5 font-bold text-sm">
                <MessageCircle className="w-4 h-4 mr-2 fill-green-500 text-green-500" />
                Chat on WhatsApp
              </Button>
            </a>
            <div className="grid grid-cols-3 gap-3 mt-5 pt-4 border-t border-slate-100">
              {[
                { v: "50K+", l: "Patients Treated" },
                { v: "98%", l: "Success Rate" },
                { v: "24/7", l: "Support Available" },
              ].map((s, i) => (
                <div key={i} className={`text-center ${i === 1 ? "border-x border-slate-100" : ""}`}>
                  <div className="text-orange-500 font-bold text-lg">{s.v}</div>
                  <div className="text-xs text-slate-500">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// ============================================
// HOW IT WORKS SCREEN
// ============================================
const HowItWorksScreen = ({ treatment }) => (
  <section className="py-16 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-14">
        <span className="text-orange-600 font-semibold text-sm uppercase tracking-widest">Step by Step</span>
        <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4">How It Works</h2>
        <p className="text-slate-500 max-w-xl mx-auto text-sm">
          From your first consultation to complete recovery, we guide you every step of the way.
        </p>
      </div>
      <div className="relative">
        <div className="hidden lg:block absolute top-20 left-0 right-0 h-0.5 bg-gradient-to-r from-orange-200 via-orange-400 to-orange-200 mx-32" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {treatment.procedure.map((step, i) => {
            const Icon = step.icon;
            return (
              <div key={i} className="relative flex flex-col items-center text-center group">
                <div className="relative z-10 mb-5">
                  <div className="w-16 h-16 bg-orange-600 rounded-2xl flex items-center justify-center shadow-lg shadow-orange-200 group-hover:scale-110 transition-transform">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-6 h-6 bg-slate-900 text-white rounded-full text-xs font-bold flex items-center justify-center">
                    {i + 1}
                  </div>
                </div>
                <div className="bg-slate-50 rounded-2xl p-5 w-full border border-slate-100 group-hover:border-orange-200 group-hover:shadow-md transition-all">
                  <h3 className="font-bold text-slate-900 mb-2 text-sm">{step.title}</h3>
                  <div className="inline-flex items-center gap-1.5 bg-orange-100 text-orange-700 rounded-full px-3 py-1 text-xs font-semibold">
                    <Clock className="w-3 h-3" />
                    {step.duration}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="mt-12 bg-slate-50 rounded-3xl p-7 border border-slate-100 flex flex-col md:flex-row items-center justify-between gap-5">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-orange-100 rounded-2xl flex items-center justify-center">
            <MessageCircle className="w-6 h-6 text-orange-600" />
          </div>
          <div>
            <div className="font-bold text-slate-900 text-sm">Have questions about the procedure?</div>
            <div className="text-slate-500 text-xs">Our care coordinators are available 24/7</div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <ConsultationModal
            trigger={
              <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-7 py-5 font-semibold text-sm">
                Book Now <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            }
          />
          <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer">
            <Button variant="outline"
              className="border-2 border-green-500 text-green-600 hover:bg-green-50 rounded-full px-7 py-5 font-semibold text-sm w-full sm:w-auto">
              <MessageCircle className="w-4 h-4 mr-2 fill-green-500 text-green-500" />
              WhatsApp Us
            </Button>
          </a>
        </div>
      </div>
    </div>
  </section>
);

// ============================================
// TESTIMONIALS SCREEN
// ============================================
const TestimonialsScreen = ({ treatment }) => (
  <section className="py-16 bg-slate-900 text-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-14">
        <span className="text-orange-400 font-semibold text-sm uppercase tracking-widest">Real Stories</span>
        <h2 className="text-3xl sm:text-4xl font-bold text-white mt-3 mb-4">Patient Success Stories</h2>
        <p className="text-slate-400 max-w-xl mx-auto text-sm">
          Hear from real patients who transformed their lives with our care.
        </p>
      </div>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12">
        <div className="text-center">
          <div className="text-6xl font-bold text-white">4.9</div>
          <div className="flex justify-center mt-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
            ))}
          </div>
          <div className="text-slate-400 text-sm mt-1">Overall Rating</div>
        </div>
        <div className="w-px h-16 bg-slate-700 hidden sm:block" />
        <div className="flex gap-8">
          {[
            { label: "Total Reviews", val: "3,000+" },
            { label: "Recommend Us", val: "99%" },
            { label: "5-Star Reviews", val: "92%" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-2xl font-bold text-orange-400">{s.val}</div>
              <div className="text-slate-400 text-xs mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-5">
        {treatment.testimonials.map((t, i) => (
          <div key={i}
            className="bg-slate-800 rounded-3xl p-6 border border-slate-700 hover:border-orange-500/50 transition-colors">
            <div className="text-4xl text-orange-500 font-serif leading-none mb-4">"</div>
            <div className="flex mb-4">
              {[...Array(t.rating)].map((_, j) => (
                <Star key={j} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
              ))}
            </div>
            <p className="text-slate-300 text-sm leading-relaxed mb-5 italic">{t.text}</p>
            <div className="inline-block bg-orange-500/20 text-orange-400 rounded-full px-3 py-1 text-xs font-medium mb-5">
              {t.treatment}
            </div>
            <div className="flex items-center gap-3 pt-4 border-t border-slate-700">
              <img src={t.image} alt={t.name}
                className="w-11 h-11 rounded-full object-cover ring-2 ring-orange-500/30" />
              <div>
                <div className="font-semibold text-white text-sm">{t.name}</div>
                <div className="text-slate-400 text-xs">Age {t.age} · {t.location} · {t.date}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <p className="text-slate-400 text-sm mb-5">Ready to write your own success story?</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <ConsultationModal
            trigger={
              <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold">
                Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            }
          />
          <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer">
            <Button variant="outline"
              className="border-2 border-green-500 text-green-600 hover:bg-green-50 rounded-full px-8 py-6 font-semibold">
              <MessageCircle className="w-4 h-4 mr-2 fill-green-500 text-green-500" />
              Chat on WhatsApp
            </Button>
          </a>
        </div>
      </div>
    </div>
  </section>
);

// ============================================
// FAQ SCREEN
// ============================================
const FAQScreen = ({ treatment }) => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-start">
          <div className="lg:sticky lg:top-24">
            <span className="text-orange-600 font-semibold text-sm uppercase tracking-widest">FAQ</span>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-slate-500 leading-relaxed mb-7 text-sm">
              Everything you need to know about {treatment.name}. Can't find the answer? We're here to help.
            </p>
            <div className="bg-gradient-to-br from-slate-50 to-orange-50 border border-orange-100 rounded-3xl p-6 space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 bg-green-100 rounded-xl flex items-center justify-center shrink-0">
                  <MessageCircle className="w-5 h-5 text-green-600" />
                </div>
                <div>
                  <div className="font-semibold text-slate-900 text-sm">Still have questions?</div>
                  <div className="text-slate-500 text-xs">We're here to help</div>
                </div>
              </div>
              <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 w-full bg-green-500 hover:bg-green-600 text-white rounded-xl py-3.5 font-semibold text-sm transition-colors shadow-md shadow-green-500/20">
                <MessageCircle className="w-4 h-4 fill-white" />
                Chat on WhatsApp
              </a>
              <div className="flex items-center justify-between pt-2 border-t border-orange-100">
                {[
                  { icon: Timer, label: "48hr reply" },
                  { icon: DollarSign, label: "Free advice" },
                  { icon: Lock, label: "Confidential" },
                ].map((item, i) => {
                  const Icon = item.icon;
                  return (
                    <div key={i} className="flex flex-col items-center gap-1">
                      <div className="w-8 h-8 bg-white rounded-lg border border-slate-200 flex items-center justify-center shadow-sm">
                        <Icon className="w-3.5 h-3.5 text-orange-500" />
                      </div>
                      <span className="text-slate-500 text-[10px] font-medium">{item.label}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="space-y-3">
            {treatment.faqs.map((faq, i) => (
              <div key={i}
                className={`border rounded-2xl overflow-hidden transition-all ${openIdx === i ? "border-orange-200 shadow-md" : "border-slate-200"}`}>
                <button onClick={() => setOpenIdx(openIdx === i ? null : i)}
                  className={`w-full flex items-center justify-between p-5 text-left transition-colors ${openIdx === i ? "bg-orange-50" : "bg-white hover:bg-slate-50"}`}>
                  <span className="font-semibold text-slate-900 text-sm pr-4 leading-relaxed">{faq.q}</span>
                  <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-colors ${openIdx === i ? "bg-orange-600" : "bg-slate-100"}`}>
                    {openIdx === i
                      ? <ChevronUp className="w-4 h-4 text-white" />
                      : <ChevronDown className="w-4 h-4 text-slate-600" />}
                  </div>
                </button>
                {openIdx === i && (
                  <div className="px-5 pb-5 bg-orange-50 border-t border-orange-100">
                    <p className="text-slate-600 text-sm leading-relaxed pt-4">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// ============================================
// FREE MEDICAL REVIEW CTA SCREEN
// ============================================
const FreeMedicalReviewScreen = () => (
  <section className="py-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl" />
      <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-green-500/10 rounded-full blur-3xl" />
    </div>
    <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <div className="inline-flex items-center gap-2 bg-green-500/20 border border-green-500/30 text-green-400 rounded-full px-4 py-1.5 text-xs font-semibold mb-6">
        <Sparkles className="w-3.5 h-3.5" />
        Free · No Commitment · 48hr Response
      </div>
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
        Ready to get a free<br />
        <span className="text-orange-400">medical review?</span>
      </h2>
      <p className="text-slate-300 text-base sm:text-lg leading-relaxed mb-8 max-w-2xl mx-auto">
        Send your reports on WhatsApp. Within 48 hours, Samar personally reviews your case and sends you a
        plain-English summary with treatment options and cost estimates.{" "}
        <span className="text-white font-semibold">Zero charge. Zero commitment.</span>
      </p>
      <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer"
        className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-2xl px-8 py-5 font-bold text-base sm:text-lg transition-all shadow-xl shadow-green-500/25 hover:shadow-green-500/40 hover:-translate-y-0.5 mb-5">
        <MessageCircle className="w-6 h-6 fill-white" />
        Send Reports on WhatsApp
      </a>
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-slate-400 mb-10">
        {["Free review", "No commitment", "Reply within 48 hours", "Zero coordination fees"].map((item, i) => (
          <span key={i} className="flex items-center gap-1.5">
            <CheckCircle className="w-3.5 h-3.5 text-green-500" />
            {item}
          </span>
        ))}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {[
          { icon: FileText, bg: "bg-orange-500/20", border: "border-orange-500/30", color: "text-orange-400", label: "Upload any format", sub: "PDF, image, scan" },
          { icon: Timer, bg: "bg-blue-500/20", border: "border-blue-500/30", color: "text-blue-400", label: "48-hour response", sub: "Personal review" },
          { icon: BadgeCheck, bg: "bg-violet-500/20", border: "border-violet-500/30", color: "text-violet-400", label: "JCI & NABH", sub: "Accredited hospitals" },
          { icon: Globe, bg: "bg-green-500/20", border: "border-green-500/30", color: "text-green-400", label: "Visa guidance", sub: "Included free" },
        ].map((card, i) => {
          const Icon = card.icon;
          return (
            <div key={i} className={`${card.bg} border ${card.border} rounded-2xl p-4 text-center`}>
              <div className={`w-10 h-10 rounded-xl ${card.bg} flex items-center justify-center mx-auto mb-3`}>
                <Icon className={`w-5 h-5 ${card.color}`} />
              </div>
              <div className="text-white font-semibold text-sm mb-0.5">{card.label}</div>
              <div className="text-slate-400 text-xs">{card.sub}</div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

// ============================================
// FLOATING CTA
// ============================================
const FloatingCTA = () => {
  const [visible, setVisible] = useState(false);
  React.useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 md:hidden bg-white border-t border-slate-200 px-4 py-3 shadow-xl">
      <div className="flex gap-3">
        <ConsultationModal
          trigger={
            <Button className="flex-1 bg-orange-600 hover:bg-orange-700 text-white rounded-xl py-5 font-semibold text-sm">
              Free Consultation
            </Button>
          }
        />
        <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer" className="flex-1">
          <Button variant="outline"
            className="w-full border-2 border-green-500 text-green-600 rounded-xl py-5 font-semibold text-sm">
            <MessageCircle className="w-4 h-4 mr-1.5 fill-green-500 text-green-500" />
            WhatsApp
          </Button>
        </a>
      </div>
    </div>
  );
};

// ============================================
// MAIN PAGE
// ============================================
const TreatmentLandingPage = () => {
  const { treatmentSlug } = useParams();
  const slug = treatmentSlug || "cardiac-surgery";
  const treatment = TREATMENTS_DATA[slug];

  if (!treatment) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="text-6xl mb-4">🔍</div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Treatment Not Found</h2>
          <p className="text-slate-500 mb-6">The treatment page you're looking for doesn't exist.</p>
          <a href="/treatments"
            className="bg-orange-600 text-white rounded-full px-8 py-3 font-semibold hover:bg-orange-700 transition-colors">
            View All Treatments
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      <HeroScreen treatment={treatment} />
      <StatsScreen treatment={treatment} />
      <WhyIndiaScreen treatment={treatment} />
      <ProcessScreen treatment={treatment} />
      <ConditionsScreen treatment={treatment} />
      <CostComparisonScreen treatment={treatment} />
      <WhyChooseScreen treatment={treatment} />
      <HowItWorksScreen treatment={treatment} />
      <TestimonialsScreen treatment={treatment} />
      <FAQScreen treatment={treatment} />
      <FreeMedicalReviewScreen />
      <FloatingCTA />
    </div>
  );
};

export default TreatmentLandingPage;